import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useGamerAuth } from './GamerAuthContext';
import ShimmerButton from './ShimmerButton';
import { db } from '../firebase';
import { doc, getDoc, setDoc, deleteDoc, collection, query, where, onSnapshot, getDocs, increment } from 'firebase/firestore';

const IconShield = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>;
const IconTarget = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>;
const IconGamepad = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const IconWallet = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>;
const IconTrophy = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" /></svg>;
const IconChart = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" /></svg>;

export default function BgmiProfile() {
    const { gamerUser, updateProfileData, logoutGamer, loading } = useGamerAuth();

    const [profile, setProfile] = useState({
        name: 'AKSHAR OP',
        username: '@akshar_gaming',
        playerId: '5123456789',
        state: 'MAHARASHTRA',
        email: 'akshar@gaming.com',
        mobile: '+91 9876543210',
        upiId: 'akshar@upi',
        trustScore: 100,
        gameUid1: '',
        gameIgn1: '',
        gameUid2: '',
        gameIgn2: '',
        primaryUidSlot: 1
    });

    useEffect(() => {
        if (gamerUser && gamerUser.profileData) {
            setProfile(prev => ({ ...prev, ...gamerUser.profileData }));
        }
    }, [gamerUser]);

    // Event listeners for Sidebar Menu buttons
    useEffect(() => {
        const handleOpenFriends = () => setShowFriendsPopup(true);
        const handleOpenEditProfile = () => {
            if (gamerUser?.isBanned) {
                alert("UNBAN APPEAL REQUEST RECEIVED.\nOur team will review your account history. Please wait 24-48 hours.");
                return;
            }
            setEditProfileData({
                name: profile.name || '',
                state: profile.state || '',
                mobile: profile.mobile || '',
                upiId: profile.upiId || ''
            });
            setShowEditProfilePopup(true);
        };
        window.addEventListener('openFriendsPopup', handleOpenFriends);
        window.addEventListener('openEditProfilePopup', handleOpenEditProfile);
        return () => {
            window.removeEventListener('openFriendsPopup', handleOpenFriends);
            window.removeEventListener('openEditProfilePopup', handleOpenEditProfile);
        };
    }, [gamerUser, profile]);

    useEffect(() => {
        const verifyUserExists = async () => {
            if (!loading) {
                if (!gamerUser) {
                    window.location.hash = '#';
                    window.dispatchEvent(new CustomEvent('showAuthToast'));
                    return;
                }

                // Explicitly check Firestore if user exists
                try {
                    const userId = gamerUser.uid || gamerUser.gamerCode;
                    if (userId) {
                        const docRef = gamerUser.uid ? doc(db, 'users', userId) : doc(db, 'gameswap', 'data', 'gamers', userId);
                        const docSnap = await getDoc(docRef);
                        if (!docSnap.exists()) {
                            if (logoutGamer) logoutGamer();
                            window.location.hash = '#';
                            alert("GAMER NOT EXISTS"); // Simple alert or dispatch custom event if you have a toast system
                            return;
                        }
                    }
                } catch (error) {
                    console.error("Error verifying user existence:", error);
                }
            }
        };
        verifyUserExists();
    }, [gamerUser, loading, logoutGamer]);
    const [showEditProfilePopup, setShowEditProfilePopup] = useState(false);
    const [showFriendsPopup, setShowFriendsPopup] = useState(false);
    const [editProfileData, setEditProfileData] = useState({ name: '', state: '', mobile: '', upiId: '' });
    const [isSavingProfile, setIsSavingProfile] = useState(false);
    const [isSavingUid, setIsSavingUid] = useState(false);
    const [notification, setNotification] = useState(null);
    const [showAddIdPopup, setShowAddIdPopup] = useState(false);
    const [newUid, setNewUid] = useState("");
    const [newIgn, setNewIgn] = useState("");
    const [fetchFailCount, setFetchFailCount] = useState(0);
    const [fetchSuccess, setFetchSuccess] = useState(false);
    const [isFetchingUid, setIsFetchingUid] = useState(false);
    const [fetchError, setFetchError] = useState("");

    const [activeSlotId, setActiveSlotId] = useState(null);
    const [slot1Removed, setSlot1Removed] = useState(false);
    const [slot2Removed, setSlot2Removed] = useState(false);
    const [showTeammatePopup, setShowTeammatePopup] = useState(false);
    const [selectedTeammate, setSelectedTeammate] = useState(null);

    // ACCOUNTS STATE
    const [showAddAccountPopup, setShowAddAccountPopup] = useState(false);
    const [isRankDropdownOpen, setIsRankDropdownOpen] = useState(false);
    const [selectedRank, setSelectedRank] = useState("");
    const [accountForm, setAccountForm] = useState({
        title: '',
        gameUid: '',
        level: '',
        collectionLevel: '',
        rank: '',
        royalPass: '',
        price: '',
        ucBalance: '',
    });
    const [accountImages, setAccountImages] = useState([null, null, null]);
    const [isListingAccount, setIsListingAccount] = useState(false);
    const [myAccounts, setMyAccounts] = useState([]);

    // VIEW ACCOUNT DETAILS STATE
    const [showAccountViewPopup, setShowAccountViewPopup] = useState(false);
    const [selectedAccountView, setSelectedAccountView] = useState(null);
    const [currentViewPhotoIndex, setCurrentViewPhotoIndex] = useState(0);

    // TEAMMATES STATE
    const [myTeammates, setMyTeammates] = useState([]);
    const [showAddTeammatePopup, setShowAddTeammatePopup] = useState(false);
    const [addTeammateForm, setAddTeammateForm] = useState({ slotId: '', name: '', uid: '', role: 'IGL', kd: '' });
    const [isSavingTeammate, setIsSavingTeammate] = useState(false);

    // REFERRAL SYSTEM STATE
    const [showReferralPopup, setShowReferralPopup] = useState(false);
    const [enteredReferralCode, setEnteredReferralCode] = useState("");
    const [isVerifyingReferral, setIsVerifyingReferral] = useState(false);
    const [referralError, setReferralError] = useState("");
    const [showQRModal, setShowQRModal] = useState(false);

    const nextViewPhoto = () => {
        if (selectedAccountView?.images) {
            setCurrentViewPhotoIndex((prev) => (prev + 1) % selectedAccountView.images.length);
        }
    };

    const prevViewPhoto = () => {
        if (selectedAccountView?.images) {
            setCurrentViewPhotoIndex((prev) => (prev - 1 + selectedAccountView.images.length) % selectedAccountView.images.length);
        }
    };

    useEffect(() => {
        if (!gamerUser) return;
        const ownerId = gamerUser.uid || gamerUser.gamerCode;
        if (!ownerId) return;

        const accountsRef = collection(db, 'bgmiAccounts');
        const qAccs = query(accountsRef, where('ownerId', '==', ownerId));
        const unsubAccs = onSnapshot(qAccs, (snapshot) => {
            const accs = [];
            snapshot.forEach((d) => {
                accs.push({ _id: d.id, ...d.data() });
            });
            setMyAccounts(accs);
        });

        const teamRef = collection(db, 'findTeammates');
        const qTeam = query(teamRef, where('ownerId', '==', ownerId));
        const unsubTeam = onSnapshot(qTeam, (snapshot) => {
            const team = [];
            snapshot.forEach((d) => {
                if (d.id.startsWith('TM_')) {
                    team.push({ _id: d.id, ...d.data() });
                }
            });
            setMyTeammates(team);
        });

        return () => {
            unsubAccs();
            unsubTeam();
        };
    }, [gamerUser]);

    // CASHOUT STATE
    const [showCashoutPopup, setShowCashoutPopup] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [cashoutState, setCashoutState] = useState("idle");
    const [eCoinsBalance, setECoinsBalance] = useState(0);
    const [bonusCoins, setBonusCoins] = useState(0);
    const [displayCoins, setDisplayCoins] = useState(0);

    const redeemableCoins = Math.max(0, eCoinsBalance - bonusCoins);
    const redeemableINR = redeemableCoins * 1.25;
    const [withdrawalHistory, setWithdrawalHistory] = useState([]);
    const [showTopUpPopup, setShowTopUpPopup] = useState(false);
    const [selectedTopUp, setSelectedTopUp] = useState(null);
    const [topUpHistory, setTopUpHistory] = useState([]);
    const [vaultHistoryTab, setVaultHistoryTab] = useState('topup');
    const [isTopUpLoading, setIsTopUpLoading] = useState(false);

    // Transfer Modal States
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [transferPlayerId, setTransferPlayerId] = useState('');
    const [targetPlayerInfo, setTargetPlayerInfo] = useState(null);
    const [transferAmountGLPC, setTransferAmountGLPC] = useState('');
    const [isFetchingPlayer, setIsFetchingPlayer] = useState(false);
    const [isTransferring, setIsTransferring] = useState(false);

    const [combatRecords, setCombatRecords] = useState({
        totalMatches: 0,
        totalWins: 0,
        totalKills: 0,
        prestigeLevel: 1,
        currentXP: 0,
        lifetimeXP: 0,
        consecutiveWins: 0
    });
    const [bountyVault, setBountyVault] = useState({
        tournamentPayouts: 0,
        eliminationBonuses: 0,
        peakWinnings: 0,
        totalCashouts: 0
    });
    const [tournamentHistory, setTournamentHistory] = useState([]);

    const syncVaultData = async (updatedData) => {
        if (!gamerUser) return;
        const userId = gamerUser.uid || gamerUser.gamerCode;
        if (!userId) return;
        try {
            const docRef = doc(db, 'users', userId, 'transactions', 'vaultData');
            await setDoc(docRef, { ...updatedData, userId }, { merge: true });
        } catch (e) {
            console.error("Error syncing vault data:", e);
        }
    };

    useEffect(() => {
        const setupListeners = async () => {
            if (gamerUser) {
                if (gamerUser.isBanned) return;
                const userId = gamerUser.uid || gamerUser.gamerCode;
                if (!userId) return;
                try {
                    const vaultRef = doc(db, 'users', userId, 'transactions', 'vaultData');
                    const unsubVault = onSnapshot(vaultRef, (vaultSnap) => {
                        if (vaultSnap.exists()) {
                            const data = vaultSnap.data();
                            if (data.eCoinsBalance !== undefined) setECoinsBalance(data.eCoinsBalance);
                            if (data.bonusCoins !== undefined) setBonusCoins(data.bonusCoins);
                            if (data.topUpHistory !== undefined) setTopUpHistory(data.topUpHistory);
                            if (data.withdrawalHistory !== undefined) setWithdrawalHistory(data.withdrawalHistory);
                        }
                    });

                    const matchesRef = doc(db, 'users', userId, 'transactions', 'matchesData');
                    const unsubMatches = onSnapshot(matchesRef, async (matchesSnap) => {
                        if (matchesSnap.exists()) {
                            const data = matchesSnap.data();
                            if (data.combatRecords !== undefined) setCombatRecords(data.combatRecords);
                            if (data.tournamentHistory !== undefined) setTournamentHistory(data.tournamentHistory);
                            if (data.bountyVault !== undefined) setBountyVault(data.bountyVault);
                        } else {
                            await setDoc(matchesRef, {
                                userId,
                                combatRecords: {
                                    totalMatches: 0,
                                    totalWins: 0,
                                    totalKills: 0,
                                    prestigeLevel: 1,
                                    currentXP: 0,
                                    lifetimeXP: 0,
                                    consecutiveWins: 0
                                },
                                bountyVault: {
                                    tournamentPayouts: 0,
                                    eliminationBonuses: 0,
                                    peakWinnings: 0,
                                    totalCashouts: 0
                                },
                                tournamentHistory: []
                            });
                        }
                    });

                    const unsubLft = onSnapshot(doc(db, 'findTeammates', userId), (lftSnap) => {
                        if (lftSnap.exists()) {
                            setLookingForTeam(true);
                        } else {
                            setLookingForTeam(false);
                        }
                    });

                    return () => {
                        unsubVault();
                        unsubMatches();
                        unsubLft();
                    };
                } catch (e) {
                    console.error("Error setting up listeners:", e);
                }
            }
        };
        const cleanup = setupListeners();
        return () => {
            if (cleanup && typeof cleanup.then === 'function') {
                cleanup.then(unsub => unsub && unsub());
            }
        };
    }, [gamerUser]);

    const [friendsList, setFriendsList] = useState([]);
    const [resolvedFriendsList, setResolvedFriendsList] = useState([]);

    useEffect(() => {
        if (!gamerUser) {
            setFriendsList([]);
            return;
        }
        const userId = String(gamerUser.uid || gamerUser.gamerCode);
        const reqRef = collection(db, 'teamRequests');

        const q1 = query(reqRef, where('senderId', '==', userId), where('status', '==', 'accepted'));
        const q2 = query(reqRef, where('receiverId', '==', userId), where('status', '==', 'accepted'));

        const u1 = onSnapshot(q1, snap => {
            setFriendsList(prev => {
                const others = prev.filter(p => p.senderId !== userId);
                const newData = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                return [...others, ...newData];
            });
        });
        const u2 = onSnapshot(q2, snap => {
            setFriendsList(prev => {
                const others = prev.filter(p => p.receiverId !== userId);
                const newData = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                return [...others, ...newData];
            });
        });

        return () => { u1(); u2(); };
    }, [gamerUser]);

    useEffect(() => {
        if (!gamerUser || friendsList.length === 0) {
            setResolvedFriendsList([]);
            return;
        }
        const currentUserId = String(gamerUser.uid || gamerUser.gamerCode);
        const resolveUids = async () => {
            const newList = await Promise.all(friendsList.map(async friend => {
                const friendData = friend.senderId === currentUserId
                    ? { name: friend.gamerData?.name || 'Unknown', uid: friend.gamerData?.uid || friend.receiverId, role: friend.gamerData?.role || 'ASSAULTER', kd: friend.gamerData?.kd || '3.0', avatar: friend.gamerData?.avatar || `https://ui-avatars.com/api/?name=${friend.gamerData?.name || 'Player'}&background=random` }
                    : { name: friend.senderName || 'Unknown', uid: friend.senderId, role: 'ASSAULTER', kd: '3.0', avatar: friend.senderAvatar || `https://ui-avatars.com/api/?name=${friend.senderName || 'Player'}&background=random` };

                let finalUid = friendData.uid;
                let isBanned = false;
                let isInactive = false;
                const friendUserId = friend.senderId === currentUserId ? friend.receiverId : friend.senderId;

                try {
                    const friendUserDoc = await getDoc(doc(db, 'users', friendUserId));
                    if (friendUserDoc.exists()) {
                        const data = friendUserDoc.data();
                        const sData = data.profileData;
                        isBanned = data.isBanned || false;
                        const trustScore = sData?.trustScore ?? 100;
                        if (trustScore <= 40) isInactive = true;

                        if (sData) {
                            const pSlot = sData.primaryUidSlot || 1;
                            finalUid = pSlot === 1 ? sData.gameUid1 : sData.gameUid2;
                        }
                    }
                } catch (e) {
                    console.error("Error fetching friend info:", e);
                }

                return {
                    ...friend,
                    resolvedName: friendData.name,
                    resolvedUid: finalUid || friendData.uid,
                    resolvedRole: friendData.role,
                    resolvedKd: friendData.kd,
                    resolvedAvatar: friendData.avatar,
                    isBanned: isBanned,
                    isInactive: isInactive
                };
            }));
            setResolvedFriendsList(newList);
        };
        resolveUids();
    }, [friendsList, gamerUser]);

    const handleTopUpSubmit = () => {
        if (!selectedTopUp) return;
        setIsTopUpLoading(true);
        setTimeout(() => {
            setIsTopUpLoading(false);
            const now = new Date();
            const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).toUpperCase();
            const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();

            const newEntry = {
                id: 'TXN' + Math.floor(100000000000 + Math.random() * 900000000000),
                amount: selectedTopUp.price.replace('₹ ', ''),
                coins: selectedTopUp.coins,
                date: `${dateStr} • ${timeStr}`,
                status: 'COMPLETED',
                timestamp: Date.now()
            };

            // Save to global transactions for admin
            if (gamerUser?.uid) {
                setDoc(doc(db, 'transactions', newEntry.id), {
                    userId: gamerUser.uid,
                    userName: gamerUser.displayName || 'Gamer',
                    type: 'TOPUP',
                    amount: newEntry.amount,
                    coins: newEntry.coins,
                    status: 'COMPLETED',
                    timestamp: newEntry.timestamp,
                    date: newEntry.date
                }).catch(e => console.error("Error saving global transaction:", e));
            }

            const newTopUpHistory = [newEntry, ...topUpHistory].slice(0, 30);
            setTopUpHistory(newTopUpHistory);

            const newBalance = eCoinsBalance + selectedTopUp.coins;
            setECoinsBalance(newBalance);
            setDisplayCoins(newBalance);

            let newBonusCoins = bonusCoins;
            if (selectedTopUp.bonus) {
                const bonusValue = parseInt(selectedTopUp.bonus.replace('+', ''), 10);
                if (!isNaN(bonusValue)) {
                    newBonusCoins += bonusValue;
                    setBonusCoins(newBonusCoins);
                }
            }

            syncVaultData({
                eCoinsBalance: newBalance,
                displayCoins: newBalance,
                bonusCoins: newBonusCoins,
                topUpHistory: newTopUpHistory
            });

            setShowTopUpPopup(false);
            setSelectedTopUp(null);
            setVaultHistoryTab('topup');
        }, 2000);
    };

    const hasPendingWithdrawal = withdrawalHistory.some(w => w.status === 'PENDING');

    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
    const recentTopUps = topUpHistory.filter(t => t.timestamp && (Date.now() - t.timestamp) < TWENTY_FOUR_HOURS).length;
    const hasReachedTopUpLimit = recentTopUps >= 2;

    const recentWithdrawals = withdrawalHistory.filter(w => w.timestamp && (Date.now() - w.timestamp) < TWENTY_FOUR_HOURS).length;
    const hasReachedWithdrawalLimit = recentWithdrawals >= 1;

    // 16 Coins = 20 INR => 1 Coin = 1.25 INR
    const getInrValue = (coins) => {
        return (coins * 1.25).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };

    // LOOKING FOR TEAM SETTINGS
    const [lookingForTeam, setLookingForTeam] = useState(false);
    const [showLftPopup, setShowLftPopup] = useState(false);
    const [lftDetails, setLftDetails] = useState({ role: '', kd: '', type: '' });
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);

    const handleLftToggle = async () => {
        if (!lookingForTeam) {
            const primaryUid = profile?.primaryUidSlot === 1 ? profile?.gameUid1 : profile?.gameUid2;
            if (!primaryUid) {
                alert("Please add at least one BGMI UID in the 'MANAGE MY ACCOUNTS' section and set it as primary before recruiting.");
                return;
            }
            setShowLftPopup(true);
        } else {
            if (gamerUser) {
                const userId = gamerUser.uid || gamerUser.gamerCode;
                try {
                    await deleteDoc(doc(db, 'findTeammates', userId));
                } catch (e) {
                    console.error("Error deleting LFT profile:", e);
                }
            }
            setLookingForTeam(false);
        }
    };

    const submitLft = async () => {
        if (lftDetails.role && lftDetails.kd && lftDetails.type && gamerUser) {
            const userId = gamerUser.uid || gamerUser.gamerCode;
            const primaryUid = profile?.primaryUidSlot === 1 ? profile?.gameUid1 : profile?.gameUid2;
            const primaryIgn = profile?.primaryUidSlot === 1 ? profile?.gameIgn1 : profile?.gameIgn2;

            try {
                await setDoc(doc(db, 'findTeammates', userId), {
                    name: primaryIgn || gamerUser.displayName || 'Gamer',
                    uid: primaryUid,
                    level: 50,
                    kd: lftDetails.kd,
                    role: lftDetails.role,
                    lookingFor: lftDetails.type,
                    avatar: gamerUser.photoURL || 'https://i.pravatar.cc/150?img=11',
                    ownerId: userId,
                    createdAt: Date.now()
                });
                setLookingForTeam(true);
                setShowLftPopup(false);
            } catch (e) {
                console.error("Error saving LFT profile:", e);
            }
        }
    };

    const animateValue = (start, end, duration) => {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            setDisplayCoins(Math.floor(progress * (end - start) + start));
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    };

    const prevECoinsRef = useRef(eCoinsBalance);

    useEffect(() => {
        if (eCoinsBalance !== prevECoinsRef.current) {
            animateValue(prevECoinsRef.current, eCoinsBalance, 1500);
            prevECoinsRef.current = eCoinsBalance;
        }
    }, [eCoinsBalance]);

    const handleWithdrawSubmit = () => {
        const amount = parseInt(withdrawAmount);
        if (isNaN(amount) || amount < 300 || amount > redeemableINR) return;

        setShowCashoutPopup(false);
        setCashoutState("loading");

        const txnId = 'TXN' + Math.floor(100000000000 + Math.random() * 900000000000);

        setTimeout(() => {
            setCashoutState("submitted");
            const coinsToDeduct = amount / 1.25;
            const newBalance = eCoinsBalance - coinsToDeduct;
            setECoinsBalance(newBalance);

            const now = new Date();
            const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).toUpperCase();
            const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();

            const newWithdrawal = {
                id: txnId,
                amount: amount,
                status: 'PENDING',
                date: `${dateStr} • ${timeStr}`,
                timestamp: Date.now()
            };

            // Save to global transactions for admin
            if (gamerUser?.uid) {
                setDoc(doc(db, 'transactions', newWithdrawal.id), {
                    userId: gamerUser.uid,
                    userName: gamerUser.displayName || 'Gamer',
                    type: 'WITHDRAWAL',
                    amount: newWithdrawal.amount,
                    status: 'PENDING',
                    timestamp: newWithdrawal.timestamp,
                    date: newWithdrawal.date
                }).catch(e => console.error("Error saving global transaction:", e));
            }

            const newWithdrawalHistory = [newWithdrawal, ...withdrawalHistory].slice(0, 30);
            setWithdrawalHistory(newWithdrawalHistory);

            syncVaultData({
                eCoinsBalance: newBalance,
                displayCoins: newBalance,
                withdrawalHistory: newWithdrawalHistory
            });

            setTimeout(() => {
                setCashoutState("idle");
                setWithdrawAmount("");
            }, 3000);
        }, 2000);
    };



    // SHOW REFERRAL POPUP ON LOAD IF APPLICABLE
    useEffect(() => {
        if (gamerUser && profile && (profile.referralCode || profile.playerId)) {
            if (!profile.referredBy && !profile.hasSkippedReferral && gamerUser.uid) {
                const timer = setTimeout(() => {
                    setShowReferralPopup(true);
                }, 1000);
                return () => clearTimeout(timer);
            }
        }
    }, [gamerUser, profile.referredBy, profile.hasSkippedReferral, profile.referralCode, profile.playerId]);

    const handleApplyReferral = async () => {
        if (!enteredReferralCode || enteredReferralCode.trim() === '') {
            setReferralError("Please enter a valid code.");
            return;
        }
        if (enteredReferralCode === profile.referralCode || enteredReferralCode === profile.playerId) {
            setReferralError("You cannot use your own code.");
            return;
        }


        setIsVerifyingReferral(true);
        setReferralError("");

        try {
            const usersRef = collection(db, 'users');
            // Check both referralCode and playerId to support older accounts that might not have referralCode set yet
            let q = query(usersRef, where('profileData.referralCode', '==', enteredReferralCode));
            let querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                q = query(usersRef, where('profileData.playerId', '==', enteredReferralCode));
                querySnapshot = await getDocs(q);
            }

            if (querySnapshot.empty) {
                setReferralError("Invalid Referral Code.");
                setIsVerifyingReferral(false);
                return;
            }

            const referrerDoc = querySnapshot.docs[0];
            const referrerId = referrerDoc.id;
            const referrerData = referrerDoc.data();

            if (updateProfileData) {
                await updateProfileData({
                    referredBy: enteredReferralCode,
                    referredByName: referrerData.profileData?.name || referrerData.displayName || "UNKNOWN USER",
                    hasSkippedReferral: true
                });
            }

            const currentCount = referrerData.profileData?.referralCount || 0;
            const currentPending = referrerData.profileData?.pendingCommission || 0;

            await setDoc(doc(db, 'users', referrerId), {
                profileData: {
                    referralCount: currentCount + 1,
                    pendingCommission: currentPending + 10
                }
            }, { merge: true });

            setNotification("REFERRAL CODE APPLIED!");
            setTimeout(() => setNotification(null), 3000);
            setShowReferralPopup(false);

        } catch (error) {
            console.error("Error applying referral:", error);
            setReferralError("Something went wrong. Try again.");
        }
        setIsVerifyingReferral(false);
    };

    const handleSkipReferral = async () => {
        if (updateProfileData) {
            await updateProfileData({ hasSkippedReferral: true });
        }
        setShowReferralPopup(false);
    };

    const getATLStatus = (score) => {
        if (score >= 100) return { text: "IMPECCABLE", color: "text-green-500" };
        if (score >= 80) return { text: "RELIABLE", color: "text-blue-500" };
        if (score >= 60) return { text: "FAIR", color: "text-yellow-500" };
        if (score >= 40) return { text: "QUESTIONABLE", color: "text-orange-500" };
        return { text: "UNTRUSTED", color: "text-red-500" };
    };

    const isBanned = gamerUser?.isBanned || false;

    const receivedReportsCount = profile?.receivedReportsCount || profile?.receivedReports || 0;
    const filedReportsCount = profile?.filedReportsCount || profile?.filedReports || 0;

    let computedTrustScore = profile?.trustScore ?? 100;
    if (computedTrustScore < 0) computedTrustScore = 0;

    const isAccountInactive = computedTrustScore <= 40;
    const accountStatus = isBanned ? "ACCOUNT BANNED" : isAccountInactive ? "ACCOUNT INACTIVE" : "ACCOUNT ACTIVE";

    const atl = getATLStatus(computedTrustScore);

    const closePopup = () => {
        setShowAddIdPopup(false);
        setNewUid("");
        setNewIgn("");
        setFetchFailCount(0);
        setFetchSuccess(false);
        setFetchError("");
        setActiveSlotId(null);
    };

    const handleSaveId = async () => {
        if (!newUid || !newIgn) return;
        setIsSavingUid(true);

        try {
            const usersRef = collection(db, 'users');
            const q1 = query(usersRef, where('profileData.gameUid1', '==', newUid));
            const q2 = query(usersRef, where('profileData.gameUid2', '==', newUid));

            const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);

            const currentUserId = gamerUser?.uid || gamerUser?.gamerCode;
            let existsInOtherProfile = false;

            snap1.forEach(doc => {
                if (doc.id !== currentUserId) existsInOtherProfile = true;
            });
            snap2.forEach(doc => {
                if (doc.id !== currentUserId) existsInOtherProfile = true;
            });

            if (existsInOtherProfile) {
                setNotification("UID ALREADY REGISTERED!");
                setTimeout(() => setNotification(null), 5000);
                setIsSavingUid(false);
                return;
            }
        } catch (error) {
            console.error("Error checking UID uniqueness:", error);
            setNotification("ERROR VERIFYING UID. PLEASE TRY AGAIN.");
            setTimeout(() => setNotification(null), 3000);
            setIsSavingUid(false);
            return;
        }

        let newData = {};
        const now = Date.now();
        if (activeSlotId === 1) {
            newData = { gameUid1: newUid, gameIgn1: newIgn, primaryUidSlot: 1, lastPrimaryUidChange: now };
        } else {
            newData = { gameUid2: newUid, gameIgn2: newIgn, primaryUidSlot: 2, lastPrimaryUidChange: now };
        }

        const updatePromise = updateProfileData ? updateProfileData(newData) : Promise.resolve();
        const timerPromise = new Promise(resolve => setTimeout(resolve, 2000));
        await Promise.all([updatePromise, timerPromise]);

        setProfile({ ...profile, ...newData });
        setIsSavingUid(false);
        closePopup();
    };

    const handleSetPrimaryUid = async (slotId) => {
        if (profile.primaryUidSlot === slotId) return;

        const TWELVE_HOURS = 12 * 60 * 60 * 1000;
        const now = Date.now();

        if (profile.lastPrimaryUidChange && (now - profile.lastPrimaryUidChange) < TWELVE_HOURS) {
            const timeLeft = TWELVE_HOURS - (now - profile.lastPrimaryUidChange);
            const hoursLeft = Math.floor(timeLeft / (1000 * 60 * 60));
            const minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

            setNotification(`YOU CAN CHANGE PRIMARY ID AGAIN IN ${hoursLeft}H ${minutesLeft}M`);
            setTimeout(() => setNotification(null), 5000);
            return;
        }

        setProfile(prev => ({ ...prev, primaryUidSlot: slotId, lastPrimaryUidChange: now }));
        if (updateProfileData) {
            await updateProfileData({ primaryUidSlot: slotId, lastPrimaryUidChange: now });
        }
    };

    const handleFetchUid = async () => {
        if (activeSlotId === 1 && profile.gameUid2 === newUid) {
            setFetchError("ID ALREADY IN SLOT 2");
            return;
        }
        if (activeSlotId === 2 && profile.gameUid1 === newUid) {
            setFetchError("ID ALREADY IN SLOT 1");
            return;
        }

        setIsFetchingUid(true);
        setFetchError("");
        setFetchSuccess(false);
        setNewIgn("");

        try {
            // Fetch directly from the standalone Cloudflare Worker API
            const response = await fetch(`https://bgmiesports.gridlabsproduction.workers.dev/?uid=${newUid}`);
            const data = await response.json();

            if (data.success) {
                setNewIgn(data.username);
                setFetchSuccess(true);
                setFetchFailCount(0);
            } else {
                throw new Error(data.error || "FAILED TO FETCH.");
            }
        } catch (error) {
            setFetchFailCount(prev => prev + 1);
            setFetchError("FAILED TO FETCH. PLEASE TRY AGAIN.");
        } finally {
            setIsFetchingUid(false);
        }
    };

    const isUpiValid = profile.upiId && profile.upiId.includes('@') && profile.upiId.trim().length > 3;

    const getRegDate = () => {
        if (gamerUser && gamerUser.joinedAt) {
            const date = new Date(gamerUser.joinedAt);
            return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).toUpperCase();
        }
        return '--';
    };

    const TWELVE_HOURS = 12 * 60 * 60 * 1000;
    const nowTime = Date.now();
    let profileLockTimeLeft = null;
    if (profile.lastProfileUpdate && (nowTime - profile.lastProfileUpdate) < TWELVE_HOURS) {
        const timeLeft = TWELVE_HOURS - (nowTime - profile.lastProfileUpdate);
        const hoursLeft = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        profileLockTimeLeft = `${hoursLeft}H ${minutesLeft}M`;
    }

    useEffect(() => {
        const anyPopupOpen = showEditProfilePopup || showFriendsPopup || showTopUpPopup || showCashoutPopup || showTeammatePopup || showAddAccountPopup || showAddTeammatePopup || showAddIdPopup;

        if (anyPopupOpen) {
            window.history.pushState({ popupOpen: true }, '');

            const handlePopState = (e) => {
                setShowEditProfilePopup(false);
                setShowFriendsPopup(false);
                setShowTopUpPopup(false);
                setShowCashoutPopup(false);
                setShowTeammatePopup(false);
                setShowAddAccountPopup(false);
                setShowAddTeammatePopup(false);
                setShowAddIdPopup(false);
            };

            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('popstate', handlePopState);
                if (window.history.state && window.history.state.popupOpen) {
                    window.history.back();
                }
            };
        }
    }, [showEditProfilePopup, showFriendsPopup, showTopUpPopup, showCashoutPopup, showTeammatePopup, showAddAccountPopup, showAddTeammatePopup, showAddIdPopup]);

    const handleListAccount = async () => {
        if (!accountForm.title || !accountForm.gameUid || !accountForm.price) {
            alert("Please fill required fields: Account Name, Game UID, and Price.");
            return;
        }

        setIsListingAccount(true);
        try {
            const imageUrls = [];
            for (let i = 0; i < accountImages.length; i++) {
                const file = accountImages[i];
                if (file) {
                    const ext = file.name.split('.').pop() || 'jpg';
                    const key = `bgmiAccounts/${accountForm.gameUid}/image_${i + 1}.${ext}`;

                    await fetch(`https://bgmiesports.gridlabsproduction.workers.dev/${key}`, {
                        method: 'PUT',
                        body: file,
                        headers: {
                            'Content-Type': file.type || 'image/jpeg'
                        }
                    });
                    imageUrls.push(`https://bgmiesports.gridlabsproduction.workers.dev/${key}`);
                }
            }

            const accDocRef = doc(db, 'bgmiAccounts', accountForm.gameUid);
            await setDoc(accDocRef, {
                title: accountForm.title,
                gameUid: accountForm.gameUid,
                level: parseInt(accountForm.level || '1'),
                collectionLevel: parseInt(accountForm.collectionLevel || '1'),
                rank: selectedRank || 'Bronze',
                royalPass: parseInt(accountForm.royalPass || '1'),
                price: parseInt(accountForm.price || '0'),
                ucBalance: parseInt(accountForm.ucBalance || '0'),
                images: imageUrls,
                status: 'PENDING',
                ownerId: gamerUser?.uid || gamerUser?.gamerCode || 'unknown',
                createdAt: Date.now()
            });

            alert("ACCOUNT LISTED SUCCESSFULLY!");
            setShowAddAccountPopup(false);
            setAccountForm({ title: '', gameUid: '', level: '', collectionLevel: '', rank: '', royalPass: '', price: '', ucBalance: '' });
            setAccountImages([null, null, null]);
            setSelectedRank("");
        } catch (e) {
            console.error(e);
            alert("Error listing account: " + e.message);
        }
        setIsListingAccount(false);
    };
    const handleFetchPlayer = async () => {
        if (!transferPlayerId || transferPlayerId.trim() === '') {
            setNotification("PLEASE ENTER A PLAYER ID");
            setTimeout(() => setNotification(null), 3000);
            return;
        }

        setIsFetchingPlayer(true);
        try {
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('profileData.playerId', '==', transferPlayerId.trim()));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                setNotification("PLAYER NOT FOUND");
                setTimeout(() => setNotification(null), 3000);
                setTargetPlayerInfo(null);
            } else {
                const targetDoc = querySnapshot.docs[0];
                const data = targetDoc.data();
                if (targetDoc.id === gamerUser.uid || targetDoc.id === gamerUser.gamerCode) {
                    setNotification("YOU CANNOT TRANSFER TO YOURSELF");
                    setTimeout(() => setNotification(null), 3000);
                    setTargetPlayerInfo(null);
                } else {
                    setTargetPlayerInfo({
                        uid: targetDoc.id,
                        name: data.profileData?.name || "GAMER",
                        playerId: data.profileData?.playerId || transferPlayerId
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching player:", error);
            setNotification("ERROR FETCHING PLAYER");
            setTimeout(() => setNotification(null), 3000);
        }
        setIsFetchingPlayer(false);
    };

    const handleTransfer = async () => {
        if (!targetPlayerInfo) return;

        const amount = parseInt(transferAmountGLPC);
        if (isNaN(amount) || amount <= 0) {
            setNotification("PLEASE ENTER A VALID AMOUNT");
            setTimeout(() => setNotification(null), 3000);
            return;
        }

        if (amount > eCoinsBalance) {
            setNotification("INSUFFICIENT GLPC BALANCE");
            setTimeout(() => setNotification(null), 3000);
            return;
        }

        setIsTransferring(true);
        try {
            const currentUserId = gamerUser.uid || gamerUser.gamerCode;
            const targetUserId = targetPlayerInfo.uid;

            if (!targetUserId) {
                throw new Error("Invalid target user ID");
            }

            // Deduct from current user
            const currentUserVaultRef = doc(db, 'users', currentUserId, 'transactions', 'vaultData');
            await setDoc(currentUserVaultRef, {
                eCoinsBalance: increment(-amount),
                displayCoins: increment(-amount),
                glpcTransferred: increment(amount) // Track how much they have transferred
            }, { merge: true });

            // Add to target user
            const targetUserVaultRef = doc(db, 'users', targetUserId, 'transactions', 'vaultData');
            await setDoc(targetUserVaultRef, {
                eCoinsBalance: increment(amount),
                displayCoins: increment(amount)
            }, { merge: true });

            // Notification for target user
            const notificationId = `transfer_${Date.now()}_${currentUserId}`;
            const targetNotifRef = doc(db, 'users', targetUserId, 'notifications', notificationId);
            await setDoc(targetNotifRef, {
                id: notificationId,
                title: 'GLPC RECEIVED',
                message: `You received ${amount} GLPC from ${profile?.name || profile?.playerId || 'a player'}.`,
                createdAt: Date.now(),
                read: false,
                type: 'transfer'
            });

            setNotification("TRANSFER SUCCESSFUL");
            setTimeout(() => setNotification(null), 3000);
            setShowTransferModal(false);
            setTransferPlayerId('');
            setTargetPlayerInfo(null);
            setTransferAmountGLPC('');
        } catch (error) {
            console.error("Error transferring GLPC:", error);
            setNotification("TRANSFER FAILED. PLEASE TRY AGAIN.");
            setTimeout(() => setNotification(null), 3000);
        }
        setIsTransferring(false);
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-[#0a0a0f] text-gray-900 dark:text-white pt-16 md:pt-24 pb-20 selection:bg-pink-500/30 font-['Monda'] uppercase">
            <AnimatePresence>
                {notification && (
                    <div className="fixed inset-x-0 top-20 md:top-6 z-[999999] flex justify-center pointer-events-none px-4">
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            className="bg-pink-500 text-white px-6 py-3 rounded-lg shadow-2xl font-black text-xs md:text-sm tracking-wider uppercase border border-pink-400 flex items-center gap-3 pointer-events-auto max-w-full"
                        >
                            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            <span className="text-center">{notification}</span>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            {/* REFERRAL POPUP */}
            <AnimatePresence>
                {showReferralPopup && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
                    >
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            className="bg-white dark:bg-[#1a1a24] rounded-xl border border-pink-500/30 p-6 max-w-sm w-full shadow-2xl relative overflow-hidden"
                        >
                            <div className="absolute top-0 right-0 w-32 h-32 bg-pink-500/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2"></div>

                            <h3 className="font-['Monda'] text-2xl font-black text-gray-900 dark:text-white uppercase mb-2">HAVE A REFERRAL CODE?</h3>
                            <p className="text-xs text-gray-500 dark:text-gray-400 font-bold uppercase mb-4">Enter it below to claim your sign-up bonus!</p>

                            <input
                                type="text"
                                placeholder="ENTER CODE (e.g. GLPC-...)"
                                value={enteredReferralCode}
                                maxLength={10}
                                onChange={(e) => setEnteredReferralCode(e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase())}
                                className="w-full bg-gray-50 dark:bg-black/50 border border-gray-200 dark:border-white/10 rounded-lg px-4 py-3 mb-2 font-['Monda'] text-lg font-black text-gray-900 dark:text-white uppercase tracking-wider focus:outline-none focus:border-pink-500 transition-colors"
                            />

                            {referralError && (
                                <p className="text-red-500 text-xs font-bold uppercase tracking-wider mb-4">{referralError}</p>
                            )}

                            <div className="flex gap-3 mt-4">
                                <button
                                    onClick={handleSkipReferral}
                                    className="flex-1 py-3 bg-gray-200 dark:bg-white/5 text-gray-700 dark:text-gray-300 rounded-lg font-black uppercase tracking-wider text-sm hover:bg-gray-300 dark:hover:bg-white/10 transition-colors"
                                >
                                    CANCEL
                                </button>
                                <button
                                    onClick={handleApplyReferral}
                                    disabled={isVerifyingReferral || !enteredReferralCode}
                                    className="flex-1 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-black uppercase tracking-wider text-sm hover:from-pink-600 hover:to-purple-700 transition-colors shadow-lg disabled:opacity-50 flex items-center justify-center"
                                >
                                    {isVerifyingReferral ? <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'APPLY'}
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <AnimatePresence>
                {showFriendsPopup && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[999999] flex items-end md:items-center justify-end p-0 md:p-[15px] bg-black/80 backdrop-blur-md"
                        onClick={() => setShowFriendsPopup(false)}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: typeof window !== 'undefined' && window.innerWidth < 768 ? "100%" : 0, x: typeof window !== 'undefined' && window.innerWidth >= 768 ? '100%' : 0 }}
                            animate={{ opacity: 1, y: 0, x: 0 }}
                            exit={{ opacity: 0, y: typeof window !== 'undefined' && window.innerWidth < 768 ? "100%" : 0, x: typeof window !== 'undefined' && window.innerWidth >= 768 ? '100%' : 0 }}
                            transition={{ type: "spring", damping: 25, stiffness: 200 }}
                            className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl w-full max-w-full md:max-w-md h-[80vh] md:h-full font-['Monda'] uppercase relative flex flex-col overflow-hidden pt-0 md:pt-0 pb-10 md:pb-[15px]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Mobile Drag Handle */}
                            <div className="w-12 h-1.5 bg-gray-300 dark:bg-white/20 rounded-full mx-auto mb-4 mt-2 md:hidden shrink-0"></div>
                            {/* Edge to edge limit tag */}
                            <div className="bg-pink-500/10 border-b border-pink-500/20 text-pink-500 text-[10px] font-black tracking-widest text-center py-1.5 -mx-[15px] mb-[15px]">
                                {resolvedFriendsList.length}/12 FRIENDS MAXIMUM
                            </div>

                            <div className="flex items-center justify-between border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] shrink-0">
                                <div className="flex gap-4 items-center">
                                    <span className="font-['Monda'] text-lg font-black uppercase tracking-wider transition-colors text-pink-500">
                                        MY FRIENDS
                                    </span>
                                </div>
                                <button onClick={() => setShowFriendsPopup(false)} className="hidden md:block text-gray-400 hover:text-pink-500 transition-colors shrink-0">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <div className="flex flex-col flex-1 overflow-y-auto pr-2 custom-scrollbar -mx-2 px-2">
                                {resolvedFriendsList.length === 0 ? (
                                    <div className="flex-1 flex items-center justify-center py-10 text-center">
                                        <p className="text-gray-500 dark:text-gray-400 text-sm font-['Monda'] font-bold uppercase tracking-wider">NO FRIENDS YET.</p>
                                    </div>
                                ) : (
                                    <div className="space-y-2">
                                        {resolvedFriendsList.map(notif => {
                                            const friendName = notif.resolvedName || 'Unknown';
                                            const friendAvatar = notif.resolvedAvatar || `https://ui-avatars.com/api/?name=${friendName}&background=random`;
                                            const friendId = notif.resolvedUid || '--';

                                            return (
                                                <div key={notif.id} className="flex items-center gap-4 py-[12px] hover:bg-gray-50 dark:hover:bg-white/5 px-3 transition-colors rounded-lg border border-gray-200 dark:border-white/10">
                                                    <div className="w-12 h-12 rounded-full bg-gray-200 dark:bg-gray-800 flex items-center justify-center text-pink-500 text-xs font-black shrink-0 overflow-hidden border-2 border-pink-500/30">
                                                        <img src={friendAvatar} alt={friendName} className="w-full h-full object-cover" />
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <h4 className="font-['Monda'] font-black text-base tracking-wider text-gray-900 dark:text-white leading-tight uppercase truncate">
                                                            {friendName}
                                                        </h4>
                                                        <p className="font-['Monda'] text-[11px] text-green-500 font-bold leading-snug uppercase tracking-wide mt-0.5">
                                                            ID: {friendId}
                                                        </p>
                                                    </div>
                                                    <button onClick={async () => {
                                                        try {
                                                            await deleteDoc(doc(db, 'teamRequests', notif.id));

                                                            const currentUserId = String(gamerUser?.uid || gamerUser?.gamerCode);
                                                            const friendUserId = notif.senderId === currentUserId ? notif.receiverId : notif.senderId;
                                                            const friendGameUid = String(notif.resolvedUid);

                                                            const myTeamRef = collection(db, 'findTeammates');

                                                            // 1. Remove friend from my team slots
                                                            const qMyTeam = query(myTeamRef, where('ownerId', '==', currentUserId), where('uid', '==', friendGameUid));
                                                            const myTeamSnap = await getDocs(qMyTeam);
                                                            myTeamSnap.forEach(async (d) => {
                                                                if (d.id.startsWith('TM_')) await deleteDoc(d.ref);
                                                            });

                                                            // 2. Remove me from friend's team slots
                                                            const pSlot = profile.primaryUidSlot || 1;
                                                            const myGameUid = String(pSlot === 1 ? profile.gameUid1 : profile.gameUid2);

                                                            if (myGameUid && myGameUid !== 'undefined') {
                                                                const qTheirTeam = query(myTeamRef, where('ownerId', '==', friendUserId), where('uid', '==', myGameUid));
                                                                const theirTeamSnap = await getDocs(qTheirTeam);
                                                                theirTeamSnap.forEach(async (d) => {
                                                                    if (d.id.startsWith('TM_')) await deleteDoc(d.ref);
                                                                });
                                                            }
                                                        } catch (e) {
                                                            console.error("Error unfriending:", e);
                                                        }
                                                    }} className="text-xs font-black text-red-500 hover:text-red-400 transition-colors uppercase px-3 py-1.5 rounded bg-red-500/10 hover:bg-red-500/20">
                                                        UNFRIEND
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className="max-w-[120rem] mx-auto px-[5px] md:px-[15px] space-y-[5px] md:space-y-[15px] mt-[5px]">

                {/* Desktop Actions */}
                <div className="hidden md:flex justify-end gap-3 mb-[15px]">
                    <button
                        onClick={(e) => {
                            if (isBanned || isAccountInactive) {
                                e.stopPropagation();
                                return;
                            }
                            window.dispatchEvent(new CustomEvent('openFriendsPopup'));
                        }}
                        disabled={isBanned || isAccountInactive}
                        className={`bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 px-6 py-2.5 rounded-xl text-sm font-['Monda'] font-black transition-all uppercase tracking-wider ${isBanned || isAccountInactive ? 'opacity-50 cursor-not-allowed' : 'hover:bg-pink-50 dark:hover:bg-pink-500/10 hover:text-pink-600 dark:hover:text-pink-400 hover:border-pink-500/30'}`}
                    >
                        MY FRIENDS
                    </button>
                    <button
                        onClick={() => window.dispatchEvent(new CustomEvent('openEditProfilePopup'))}
                        disabled={isBanned}
                        className={`bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 px-6 py-2.5 rounded-xl text-sm font-['Monda'] font-black transition-all uppercase tracking-wider ${isBanned ? 'opacity-50 cursor-not-allowed' : 'hover:bg-pink-50 dark:hover:bg-pink-500/10 hover:text-pink-600 dark:hover:text-pink-400 hover:border-pink-500/30'}`}
                    >
                        EDIT PROFILE
                    </button>
                    <button onClick={() => { if (logoutGamer) logoutGamer(); window.location.hash = '#'; }} className="bg-red-500 text-white px-6 py-2.5 rounded-xl text-sm font-['Monda'] font-black hover:bg-red-600 transition-all uppercase tracking-wider shadow-lg shadow-red-500/20">
                        LOGOUT
                    </button>
                </div>

                {/* 1. Basic Profile & 2. Fair Play (Top Section Merged) */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="relative md:bg-white/80 md:dark:bg-[#1a1a24]/80 md:backdrop-blur-xl md:border md:border-gray-200 md:dark:border-white/5 md:rounded-none md:p-[20px] md:shadow-sm md:dark:shadow-none"
                >

                    <div className="grid grid-cols-1 2xl:grid-cols-2 gap-[5px] md:gap-[15px]">

                        {/* Basic Profile */}
                        <div className="flex flex-col 2xl:col-span-1 border-b border-gray-200 dark:border-white/5 2xl:border-b-0 pb-[5px] md:pb-[15px] 2xl:pb-0">

                            <div className="flex flex-col lg:grid lg:grid-cols-4 items-stretch gap-[5px] md:gap-[15px] mb-[5px] md:mb-[15px]">
                                <div className="flex items-center gap-[5px] md:gap-[15px] w-full lg:col-span-2">
                                    <div className="w-24 sm:w-28 h-24 sm:h-28 shrink-0 rounded-none border-2 border-pink-500/30 overflow-hidden bg-gray-200 dark:bg-[#111]">
                                        <img src="https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=300&q=80" alt="Avatar" className="w-full h-full object-cover" />
                                    </div>

                                    <div className="bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/10 flex flex-col justify-center h-24 sm:h-28 flex-1">
                                        <span className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">PLAYER</span>
                                        <div className="flex flex-col overflow-hidden">
                                            <span className="font-black text-base sm:text-lg text-gray-900 dark:text-white truncate uppercase tracking-wider">{profile.name}</span>
                                            <span className="text-[9px] sm:text-[10px] text-pink-600 dark:text-pink-400 font-bold tracking-widest truncate">{profile.username}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full lg:col-span-2 grid grid-cols-2 gap-[5px] md:gap-[15px]">
                                    {/* Game UID 1 (Pink Theme) */}
                                    {profile.gameUid1 ? (
                                        <div onClick={() => { if (!isBanned && !isAccountInactive) handleSetPrimaryUid(1); }} className={`bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border flex flex-col justify-center h-24 sm:h-28 relative overflow-hidden transition-colors ${profile.primaryUidSlot === 1 ? 'border-pink-500/50 dark:border-pink-500/50' : 'border-gray-200 dark:border-white/10'} ${isBanned || isAccountInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-pink-500'}`}>
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">GAME UID 1</span>
                                                {profile.primaryUidSlot === 1 && (
                                                    <span className="text-[8px] bg-pink-500 text-white px-2 py-1 rounded-bl-lg font-bold tracking-widest uppercase absolute top-0 right-0 shadow-sm">PRIMARY</span>
                                                )}
                                            </div>
                                            <div className="flex flex-col overflow-hidden">
                                                <span className="font-black text-sm sm:text-lg text-gray-900 dark:text-white truncate uppercase tracking-wider">{profile.gameUid1}</span>
                                                <span className="text-[9px] sm:text-[10px] text-pink-600 dark:text-pink-400 font-bold tracking-widest truncate">IGN: {profile.gameIgn1}</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div onClick={() => { if (!isBanned && !isAccountInactive) { setActiveSlotId(1); setShowAddIdPopup(true); } }} className={`bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/10 flex flex-col justify-center items-center h-24 sm:h-28 transition-colors group ${isBanned || isAccountInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-pink-500'}`}>
                                            <span className="text-2xl sm:text-3xl text-gray-400 dark:text-gray-500 font-light mb-1 group-hover:scale-110 transition-transform">+</span>
                                            <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">ADD UID 1</span>
                                        </div>
                                    )}

                                    {/* Game UID 2 (Purple Theme) */}
                                    {profile.gameUid2 ? (
                                        <div onClick={() => { if (!isBanned && !isAccountInactive) handleSetPrimaryUid(2); }} className={`bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border flex flex-col justify-center h-24 sm:h-28 relative overflow-hidden transition-colors ${profile.primaryUidSlot === 2 ? 'border-purple-500/50 dark:border-purple-500/50' : 'border-gray-200 dark:border-white/10'} ${isBanned || isAccountInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-purple-500'}`}>
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">GAME UID 2</span>
                                                {profile.primaryUidSlot === 2 && (
                                                    <span className="text-[8px] bg-purple-500 text-white px-2 py-1 rounded-bl-lg font-bold tracking-widest uppercase absolute top-0 right-0 shadow-sm">PRIMARY</span>
                                                )}
                                            </div>
                                            <div className="flex flex-col overflow-hidden">
                                                <span className="font-black text-sm sm:text-lg text-gray-900 dark:text-white truncate uppercase tracking-wider">{profile.gameUid2}</span>
                                                <span className="text-[9px] sm:text-[10px] text-purple-600 dark:text-purple-400 font-bold tracking-widest truncate">IGN: {profile.gameIgn2}</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div onClick={() => { if (!isBanned && !isAccountInactive) { setActiveSlotId(2); setShowAddIdPopup(true); } }} className={`bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/10 flex flex-col justify-center items-center h-24 sm:h-28 transition-colors group ${isBanned || isAccountInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-purple-500'}`}>
                                            <span className="text-2xl sm:text-3xl text-gray-400 dark:text-gray-500 font-light mb-1 group-hover:scale-110 transition-transform">+</span>
                                            <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">ADD UID 2</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Stats */}
                            <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-[5px] md:gap-[15px] mt-auto">
                                <div className="lg:col-span-2 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">PLAYER ID</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm truncate">{profile.playerId}</span>
                                </div>
                                <div className="lg:col-span-1 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">REG. DATE</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm">{getRegDate()}</span>
                                </div>
                                <div className="lg:col-span-1 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">STATE</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm truncate">{profile.state}</span>
                                </div>
                                <div className="lg:col-span-2 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">EMAIL</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm uppercase truncate">{profile.email}</span>
                                </div>
                                <div className="lg:col-span-1 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">MOBILE</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm uppercase truncate">{profile.mobile || "--"}</span>
                                </div>
                                <div className="lg:col-span-1 bg-gray-50 dark:bg-[#1a1a24]/60 p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                    <span className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">UPI ID</span>
                                    <span className="font-black text-gray-900 dark:text-white text-[11px] sm:text-sm uppercase truncate">{profile.upiId || "--"}</span>
                                </div>
                            </div>
                        </div>

                        {/* Fair Play */}
                        <div className="flex flex-col 2xl:col-span-1">

                            <div className="flex items-center gap-[5px] md:gap-[15px] mb-[5px] md:mb-[15px]">
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5 }}
                                    className={`w-28 h-28 shrink-0 rounded-none border-2 border-current bg-current/5 flex flex-col items-center justify-center relative overflow-hidden text-center ${atl.color}`}
                                >
                                    <div className="absolute inset-0 bg-gradient-to-tr from-current/10 to-transparent"></div>
                                    <span className="text-4xl font-black leading-none mb-1 relative z-10">{computedTrustScore}</span>
                                    <span className="text-[10px] font-bold uppercase tracking-widest relative z-10 leading-tight">TRUST<br />SCORE</span>
                                </motion.div>

                                <div className="flex-1 grid grid-cols-2 gap-[5px] md:gap-[10px] h-28">
                                    <div className={`${isBanned || isAccountInactive ? 'bg-red-500/10 border-red-500/20' : 'bg-green-500/10 border-green-500/20'} px-1 sm:px-3 rounded-none flex items-center justify-between h-full overflow-hidden border`}>
                                        <span className={`text-[10px] md:text-sm font-black uppercase leading-tight truncate ${isBanned || isAccountInactive ? 'text-red-600 dark:text-red-500' : 'text-green-600 dark:text-green-500'}`}>{accountStatus}</span>
                                        {isBanned || isAccountInactive ? (
                                            <svg className="w-4 h-4 md:w-5 md:h-5 text-red-500 shrink-0 ml-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg>
                                        ) : (
                                            <svg className="w-4 h-4 md:w-5 md:h-5 text-green-500 shrink-0 ml-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                        )}
                                    </div>
                                    <div className={`${isUpiValid ? 'bg-purple-500/10 border-purple-500/20' : 'bg-red-500/10 border-red-500/20'} border px-1 sm:px-3 rounded-none flex items-center justify-between h-full overflow-hidden`}>
                                        <span className={`text-[10px] md:text-sm font-black uppercase leading-tight truncate ${isUpiValid ? 'text-purple-600 dark:text-purple-400' : 'text-red-600 dark:text-red-400'}`}>UPI STATUS</span>
                                        {isUpiValid ? (
                                            <svg className="w-4 h-4 md:w-5 md:h-5 text-purple-500 shrink-0 ml-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                        ) : (
                                            <svg className="w-4 h-4 md:w-5 md:h-5 text-red-500 shrink-0 ml-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg>
                                        )}
                                    </div>
                                    <div className="bg-gray-50 dark:bg-[#111] border border-gray-200 dark:border-white/10 px-2 sm:px-3 rounded-none flex flex-col justify-center h-full overflow-hidden">
                                        <span className="text-[8px] md:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 truncate">RECEIVED REPORTS</span>
                                        <span className={`text-[11px] md:text-sm font-black uppercase truncate ${receivedReportsCount > 0 ? 'text-red-500' : 'text-green-500'}`}>{receivedReportsCount}</span>
                                    </div>
                                    <div className="bg-gray-50 dark:bg-[#111] border border-gray-200 dark:border-white/10 px-2 sm:px-3 rounded-none flex flex-col justify-center h-full overflow-hidden">
                                        <span className="text-[8px] md:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 truncate">FILED REPORTS</span>
                                        <span className="text-[11px] md:text-sm font-black text-gray-900 dark:text-white uppercase truncate">{filedReportsCount}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Stats */}
                            <div className="flex-1 w-full grid grid-cols-2 gap-[5px] md:gap-[15px] mt-[5px] md:mt-auto">
                                <div className="bg-gray-50 dark:bg-[#1a1a24]/60 px-2 sm:px-4 py-2 sm:py-3 rounded-none border border-gray-200 dark:border-white/5 flex items-center justify-between">
                                    <p className="text-[10px] md:text-sm font-black text-gray-500 dark:text-gray-400 uppercase leading-tight truncate">ATS</p>
                                    <p className={`text-[10px] md:text-sm font-black uppercase text-right shrink-0 ml-1 md:ml-2 ${atl.color}`}>{atl.text}</p>
                                </div>
                                <div className="border border-gray-200 dark:border-white/10 p-[15px] flex justify-between items-center bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                                    <p className="text-[10px] md:text-sm font-black text-gray-500 dark:text-gray-400 uppercase leading-tight truncate">RECEIVED REPORTS</p>
                                    <p className="text-base md:text-2xl font-black text-gray-900 dark:text-white uppercase shrink-0 ml-1 md:ml-2">{receivedReportsCount}</p>
                                </div>
                                <div className="border border-gray-200 dark:border-white/10 p-[15px] flex justify-between items-center bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                                    <p className="text-[10px] md:text-sm font-black text-gray-500 dark:text-gray-400 uppercase leading-tight truncate">FILED REPORTS</p>
                                    <p className="text-base md:text-2xl font-black text-gray-900 dark:text-white uppercase shrink-0 ml-1 md:ml-2">{filedReportsCount}</p>
                                </div>
                                <div className="border border-gray-200 dark:border-white/10 p-[15px] flex justify-between items-center bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                                    <p className="text-[10px] md:text-sm font-black text-gray-500 dark:text-gray-400 uppercase leading-tight truncate">CONFIRMED REPORTS</p>
                                    <p className="text-base md:text-2xl font-black text-gray-900 dark:text-white uppercase shrink-0 ml-1 md:ml-2">{profile.confirmedReportsCount || 0}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </motion.div>

                {/* 3. BGMI Statistics & 4. Earnings */}
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-[5px] md:gap-[15px]">

                    <div className="flex flex-col gap-[5px] md:gap-[15px] h-full">
                        {/* COMBAT RECORDS */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="flex-1 flex flex-col justify-between bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none p-[10px] md:p-[15px] shadow-sm dark:shadow-none"
                        >
                            <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                                <div className="text-purple-600 dark:text-purple-400 hidden md:block"><IconGamepad /></div>
                                <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">COMBAT RECORDS</h3>
                            </div>

                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-[5px] md:gap-[15px]">
                                {[
                                    { label: "TOTAL MATCHES", value: combatRecords.totalMatches },
                                    { label: "TOTAL WINS", value: combatRecords.totalWins, color: "text-yellow-500" },
                                    { label: "TOTAL KILLS", value: combatRecords.totalKills, color: "text-pink-500" },
                                    { label: "WIN RATE", value: combatRecords.totalMatches > 0 ? ((combatRecords.totalWins / combatRecords.totalMatches) * 100).toFixed(1) + '%' : '0.0%', color: "text-blue-500 dark:text-blue-400" },
                                    { label: "SURVIVAL RATE", value: combatRecords.totalMatches > 0 ? (((combatRecords.top10s || combatRecords.totalWins) / combatRecords.totalMatches) * 100).toFixed(1) + '%' : '0.0%', color: "text-green-500 dark:text-green-400" },
                                    { label: "F/D RATIO", value: combatRecords.totalMatches > 0 ? (combatRecords.totalKills / combatRecords.totalMatches).toFixed(2) : '0.00', color: "text-purple-500 dark:text-purple-400" },
                                ].map((stat, i) => (
                                    <div key={i} className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5">
                                        <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1 md:mb-2">{stat.label}</p>
                                        <p className={`text-lg md:text-xl font-black uppercase ${stat.color || 'text-gray-900 dark:text-white'}`}>{stat.value}</p>
                                    </div>
                                ))}
                            </div>

                        </motion.div>

                        {/* PRESTIGE & XP */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="flex-1 flex flex-col justify-between bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none p-[10px] md:p-[15px] shadow-sm dark:shadow-none"
                        >
                            <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                                <svg className="w-6 h-6 text-yellow-500 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" /></svg>
                                <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">PRESTIGE & XP</h3>
                            </div>

                            <div className="flex items-end justify-between mb-[5px] md:mb-[15px]">
                                <div>
                                    <span className="text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest block mb-1">CURRENT PRESTIGE</span>
                                    <span className="text-2xl md:text-4xl font-black text-purple-600 dark:text-purple-400">Lv. {combatRecords.prestigeLevel}</span>
                                </div>
                                <div className="text-right">
                                    <span className="text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest block mb-1">NEXT RANK</span>
                                    <span className="text-lg md:text-xl font-black text-gray-900 dark:text-white">Lv. {combatRecords.prestigeLevel + 1}</span>
                                </div>
                            </div>

                            <div className="w-full h-3 bg-gray-200 dark:bg-[#111] rounded-full overflow-hidden mb-[5px] md:mb-[15px]">
                                <motion.div
                                    initial={{ width: 0 }}
                                    whileInView={{ width: `${Math.min(100, (combatRecords.currentXP / (combatRecords.prestigeLevel * 100)) * 100)}%` }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
                                    className="h-full bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"
                                ></motion.div>
                            </div>

                            <div className="flex justify-between items-center text-[10px] md:text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-[5px] md:mb-[15px]">
                                <span>{combatRecords.currentXP} / {combatRecords.prestigeLevel * 100} XP</span>
                                <span>{(combatRecords.prestigeLevel * 100) - combatRecords.currentXP} XP TO NEXT</span>
                            </div>


                            <div className="grid grid-cols-2 gap-[5px] md:gap-[15px]">
                                <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col items-center justify-center text-center">
                                    <span className="text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 md:mb-2">LIFETIME XP</span>
                                    <span className="text-xl md:text-2xl font-black text-gray-900 dark:text-white">{combatRecords.lifetimeXP}</span>
                                </div>
                                <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col items-center justify-center text-center">
                                    <span className="text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 md:mb-2">CONSECUTIVE WINS</span>
                                    <span className="text-xl md:text-2xl font-black text-gray-900 dark:text-white">{combatRecords.consecutiveWins}</span>
                                </div>
                            </div>

                        </motion.div>
                    </div>

                    {/* Earnings */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="h-full flex flex-col justify-between bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none p-[10px] md:p-[15px] shadow-sm dark:shadow-none"
                    >
                        <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                            <div className="text-pink-600 dark:text-pink-400 hidden md:block"><IconWallet /></div>
                            <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">BOUNTY VAULT</h3>
                        </div>

                        <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] mb-[5px] md:mb-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                            <div className="flex justify-between items-center mb-1 md:mb-2">
                                <div>
                                    <p className="text-xs md:text-sm text-pink-600 dark:text-pink-400 font-bold uppercase tracking-widest mb-0.5 md:mb-1">GLPC</p>
                                    <p className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white flex items-center gap-1.5 md:gap-2">
                                        <span className="text-pink-500 text-2xl md:text-3xl">🪙</span>{displayCoins}
                                    </p>
                                </div>
                                <div className="text-right">
                                    <p className="text-xs md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-0.5 md:mb-1">VALUE IN INR</p>
                                    <p className="text-2xl md:text-3xl font-black text-gray-400 dark:text-gray-500">₹ {getInrValue(displayCoins)}</p>
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row items-start md:items-end justify-between border-t border-gray-200 dark:border-white/10 pt-2 md:pt-3 mt-2 md:mt-3 gap-3 md:gap-0">
                                <div>
                                    <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-0.5 md:mb-1">REDEEMABLE BALANCE</p>
                                    <p className="text-lg md:text-xl font-bold text-green-600 dark:text-green-400 leading-none">₹ {isBanned || isAccountInactive ? 0 : getInrValue(Math.max(0, displayCoins - bonusCoins))}</p>
                                    <p className="text-[8px] md:text-[10px] text-gray-500 dark:text-gray-500 font-semibold mt-1 uppercase tracking-wider">* MIN. REDEEM AMOUNT: ₹ 300</p>
                                </div>
                                <div className="flex gap-[5px] md:gap-[10px] w-full md:w-auto">
                                    <button
                                        onClick={() => !(isBanned || isAccountInactive) && !hasReachedTopUpLimit && setShowTopUpPopup(true)}
                                        disabled={isBanned || isAccountInactive || hasReachedTopUpLimit}
                                        className={`flex-1 md:flex-none text-white text-xs md:text-sm font-black font-['Monda'] uppercase tracking-wider py-1.5 md:py-2 px-3 md:px-5 rounded-full transition-all duration-300 shadow-md flex items-center justify-center ${isBanned || isAccountInactive || hasReachedTopUpLimit ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed opacity-50' : 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700'
                                            }`}
                                    >
                                        {isBanned || isAccountInactive ? "DISABLED" : hasReachedTopUpLimit ? "LIMIT REACHED" : "TOP-UP"}
                                    </button>
                                    <button
                                        onClick={() => {
                                            if (isBanned || isAccountInactive) return;
                                            if (!profile.upiId || profile.upiId.trim() === '') {
                                                setNotification("PLEASE SET UPI ID FIRST");
                                                setTimeout(() => setNotification(null), 3000);
                                                return;
                                            }
                                            if (cashoutState === 'idle' && !hasPendingWithdrawal && !hasReachedWithdrawalLimit && redeemableINR >= 300) {
                                                setShowCashoutPopup(true);
                                            }
                                        }}
                                        disabled={isBanned || isAccountInactive || cashoutState !== 'idle' || hasPendingWithdrawal || hasReachedWithdrawalLimit || redeemableINR < 300}
                                        className={`flex-1 md:flex-none text-white text-xs md:text-sm font-black font-['Monda'] uppercase tracking-wider py-1.5 md:py-2 px-3 md:px-5 rounded-full transition-all duration-300 shadow-md flex items-center justify-center min-w-0 md:min-w-[120px] ${!(isBanned || isAccountInactive) && cashoutState === 'idle' && !hasPendingWithdrawal && !hasReachedWithdrawalLimit && redeemableINR >= 300 ? 'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700' :
                                            'bg-gray-400 dark:bg-gray-600 cursor-not-allowed opacity-50'
                                            }`}
                                    >
                                        {isBanned || isAccountInactive ? "DISABLED" :
                                            hasReachedWithdrawalLimit ? "LIMIT REACHED" :
                                                hasPendingWithdrawal ? "NOT ALLOWED" :
                                                    cashoutState === 'idle' ? "CASHOUT" :
                                                        cashoutState === 'loading' ? <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> :
                                                            "SUBMITTED"
                                        }
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            if (isBanned || isAccountInactive) return;
                                            if (resolvedFriendsList.length === 0) {
                                                setNotification("NO FRIENDS AVAILABLE TO TRANSFER GLPC");
                                                setTimeout(() => setNotification(null), 3000);
                                                return;
                                            }
                                            setShowTransferModal(true);
                                        }}
                                        className={`flex-1 md:flex-none text-white text-xs md:text-sm font-black font-['Monda'] uppercase tracking-wider py-1.5 md:py-2 px-3 md:px-5 rounded-full transition-all duration-300 shadow-md flex items-center justify-center ${isBanned || isAccountInactive || resolvedFriendsList.length === 0 ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed opacity-50' : 'bg-gradient-to-r from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600'
                                            }`}
                                    >
                                        TRANSFER
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 md:grid-cols-2 gap-[5px] md:gap-[15px] flex-1">
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">TOURNAMENT PAYOUTS</p>
                                <p className="text-lg md:text-xl font-black text-gray-900 dark:text-white">₹ {bountyVault.tournamentPayouts || 0}</p>
                            </div>
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">ELIMINATION BONUSES</p>
                                <p className="text-lg md:text-xl font-black text-gray-900 dark:text-white">₹ {bountyVault.eliminationBonuses || 0}</p>
                            </div>
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">PEAK WINNINGS</p>
                                <p className="text-lg md:text-xl font-black text-purple-600 dark:text-purple-400">₹ {bountyVault.peakWinnings || 0}</p>
                            </div>
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">TOTAL CASHOUTS</p>
                                <p className="text-lg md:text-xl font-black text-gray-900 dark:text-white">₹ {bountyVault.totalCashouts || 0}</p>
                            </div>
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">XP EXCHANGED</p>
                                <p className="text-lg md:text-xl font-black text-blue-500 dark:text-blue-400">{bountyVault.xpExchanged || 0} XP</p>
                            </div>
                            <div className="bg-gray-50 dark:bg-[#111] p-[10px] md:p-[15px] rounded-none border border-gray-200 dark:border-white/5 flex flex-col justify-center">
                                <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">GLPC TRANSFERRED</p>
                                <p className="text-lg md:text-xl font-black text-yellow-500 dark:text-yellow-400">{bountyVault.glpcTransferred || 0}</p>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* 5. Referral System */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="relative overflow-hidden bg-gradient-to-r from-pink-600/10 via-purple-600/10 to-indigo-600/10 dark:from-pink-900/20 dark:via-purple-900/20 dark:to-indigo-900/20 backdrop-blur-xl border border-pink-500/30 rounded-none p-[10px] md:p-[20px] shadow-[0_0_20px_rgba(219,39,119,0.15)]"
                >
                    {/* Decorative Elements */}
                    <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500/20 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500/20 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

                    <div className="relative z-10 flex flex-col w-full">
                        {/* Left Side: Text and Info */}
                        <div className="flex-1 flex flex-col w-full">
                            <div className="flex items-center justify-start md:justify-start gap-3 mb-2 border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full md:border-b-0 md:pb-0">
                                <div className="text-pink-600 dark:text-pink-500 hidden md:block">
                                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                    </svg>
                                </div>
                                <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-left w-full md:w-auto">
                                    <span className="md:hidden">REFER & EARN RS 10 PER REFERRAL</span>
                                    <span className="hidden md:inline">REFER & EARN</span>
                                </h3>
                            </div>
                            <p className="hidden md:block text-sm md:text-base font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider mb-4 leading-relaxed text-center md:text-left">
                                Invite your squad and earn a flat <span className="text-pink-600 dark:text-pink-400 font-black text-xl mx-1">₹10</span> commission on every successful referral! Build your team and stack up the rewards.
                            </p>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-[5px] md:gap-[15px] w-full mt-[5px] md:mt-auto">
                                <div className="bg-white/60 dark:bg-black/40 p-[5px] md:px-4 md:py-3 rounded-none border border-pink-500/20 flex flex-col justify-center items-center text-center w-full">
                                    <span className="font-['Monda'] text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 leading-tight">REFERRALS</span>
                                    <span className="text-xl md:text-2xl font-black text-gray-900 dark:text-white">{profile.referralCount || 0}</span>
                                </div>
                                <div className="bg-white/60 dark:bg-black/40 p-[5px] md:px-4 md:py-3 rounded-none border border-yellow-500/20 flex flex-col justify-center items-center text-center w-full">
                                    <span className="font-['Monda'] text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 leading-tight">PENDING</span>
                                    <span className="text-xl md:text-2xl font-black text-yellow-600 dark:text-yellow-400">₹ {profile.pendingCommission || 0}</span>
                                </div>
                                <div className="bg-white/60 dark:bg-black/40 p-[5px] md:px-4 md:py-3 rounded-none border border-green-500/20 flex flex-col justify-center items-center text-center w-full">
                                    <span className="font-['Monda'] text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 leading-tight">CONFIRMED</span>
                                    <span className="text-xl md:text-2xl font-black text-green-600 dark:text-green-400">₹ {profile.confirmedCommission || 0}</span>
                                </div>

                                {/* 4th Card: Referral Code */}
                                <div
                                    className="bg-white/60 dark:bg-black/40 p-[5px] md:px-4 md:py-3 rounded-none border border-pink-500/50 flex flex-col justify-center items-center text-center w-full cursor-pointer hover:bg-pink-500/10 transition-colors relative group"
                                    onClick={() => {
                                        const code = profile.referralCode || profile.playerId || "GLPC-REF-001";
                                        navigator.clipboard.writeText(code);
                                        setNotification("REFERRAL CODE COPIED!");
                                        setTimeout(() => setNotification(null), 3000);
                                    }}
                                >
                                    <span className="font-['Monda'] text-[10px] md:text-sm text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest mb-1 leading-tight">YOUR CODE</span>
                                    <span className="text-xl md:text-2xl font-black text-pink-600 dark:text-pink-400 truncate w-full px-2" title={profile.referralCode || profile.playerId || "GLPC-REF-001"}>
                                        {profile.referralCode || profile.playerId || "GLPC-REF-001"}
                                    </span>

                                    {/* QR Icon Button */}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation(); // prevent copying
                                            setShowQRModal(true);
                                        }}
                                        className="absolute top-1 md:top-2 right-1 md:right-2 p-1 md:p-1.5 bg-pink-500/10 text-pink-500 hover:bg-pink-500 hover:text-white rounded transition-colors"
                                        title="Show QR Code"
                                    >
                                        <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm14 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"></path></svg>
                                    </button>
                                </div>
                            </div>

                            {profile.referredBy && (
                                <div className="mt-4 flex items-center gap-2 bg-white/40 dark:bg-white/5 px-3 py-2 rounded-none border border-gray-200 dark:border-white/10 w-fit">
                                    <span className="text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest">REFERRED BY:</span>
                                    <span className="text-xs font-black text-purple-600 dark:text-purple-400 uppercase tracking-widest">{profile.referredByName || profile.referredBy}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </motion.div>

                {/* 8. History Section (Tournament & Withdrawal) */}
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-[5px] md:gap-[15px] mt-[5px] md:mt-[15px]">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none md:rounded-lg p-[5px] md:p-[15px] shadow-sm dark:shadow-none overflow-hidden flex flex-col min-h-[350px]"
                    >
                        <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                            <svg className="w-6 h-6 text-gray-500 dark:text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg>
                            <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">TOURNAMENT HISTORY</h3>
                        </div>
                        <div className="overflow-x-auto overflow-y-auto max-h-[280px] pb-4 flex-1 custom-scrollbar">
                            <table className="w-full text-left min-w-[700px]">
                                <thead className="sticky top-0 bg-white dark:bg-[#1a1a24] z-10 shadow-sm">
                                    <tr className="border-b border-gray-200 dark:border-white/10 text-gray-500 dark:text-gray-400 text-xs font-bold uppercase tracking-wider">
                                        <th className="py-[15px] px-4 whitespace-nowrap text-left align-middle border-r border-gray-200 dark:border-white/10">Tournament</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle border-r border-gray-200 dark:border-white/10">Position</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle border-r border-gray-200 dark:border-white/10">Kills</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center text-purple-500 align-middle border-r border-gray-200 dark:border-white/10">XP Earned</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle">Prize</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tournamentHistory?.length > 0 ? [...tournamentHistory].reverse().slice(0, 30).map((t, i) => (
                                        <tr key={i} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors divide-x divide-gray-100 dark:divide-white/5">
                                            <td className="py-4 px-4 whitespace-nowrap text-left font-bold text-gray-900 dark:text-white uppercase text-sm">{t.title || t.name || "CUSTOM MATCH"}</td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center text-gray-600 dark:text-gray-300 font-bold uppercase text-sm">#{t.pos}</td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center text-gray-600 dark:text-gray-300 font-bold uppercase text-sm">{t.kills}</td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center text-purple-600 dark:text-purple-400 font-black uppercase text-sm">
                                                +{t.xp} XP
                                            </td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center font-black text-green-600 dark:text-green-400 uppercase text-sm">{t.prize}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="5" className="py-8 text-center text-gray-500 dark:text-gray-400 font-bold text-sm uppercase">No matches played yet</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none md:rounded-lg p-[5px] md:p-[15px] shadow-sm dark:shadow-none overflow-hidden flex flex-col relative min-h-[350px]"
                    >
                        {/* Top-Right Toggle Button */}
                        <button
                            onClick={() => setVaultHistoryTab(prev => prev === 'topup' ? 'withdraw' : 'topup')}
                            className={`absolute top-0 right-0 px-4 py-1.5 text-[10px] font-bold uppercase rounded-bl-lg transition-colors ${vaultHistoryTab === 'topup' ? 'bg-pink-500 text-white hover:bg-pink-600' : 'bg-purple-500 text-white hover:bg-purple-600'}`}
                        >
                            {vaultHistoryTab === 'topup' ? 'REDEEM HISTORY' : 'TOP-UP HISTORY'}
                        </button>

                        <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full mt-2 md:mt-0">
                            <svg className="w-6 h-6 text-gray-500 dark:text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                            <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">
                                {vaultHistoryTab === 'topup' ? 'TOP-UP HISTORY' : 'WITHDRAWAL HISTORY'}
                            </h3>
                        </div>
                        <div className="overflow-x-auto overflow-y-auto max-h-[280px] pb-4 flex-1 custom-scrollbar">
                            <table className="w-full text-left min-w-[700px]">
                                <thead className="sticky top-0 bg-white dark:bg-[#1a1a24] z-10 shadow-sm">
                                    <tr className="border-b border-gray-200 dark:border-white/10 text-gray-500 dark:text-gray-400 text-xs font-bold uppercase tracking-wider">
                                        <th className="py-[15px] px-4 whitespace-nowrap text-left align-middle border-r border-gray-200 dark:border-white/10">TXN ID</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle border-r border-gray-200 dark:border-white/10">{vaultHistoryTab === 'topup' ? 'PAID AMOUNT' : 'WITHDRAWN'}</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle border-r border-gray-200 dark:border-white/10">{vaultHistoryTab === 'topup' ? 'RECEIVED COINS' : 'USED COINS'}</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle border-r border-gray-200 dark:border-white/10">Status</th>
                                        <th className="py-[15px] px-4 whitespace-nowrap text-center align-middle">Date & Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(vaultHistoryTab === 'topup' ? topUpHistory : withdrawalHistory).length > 0 ? (vaultHistoryTab === 'topup' ? topUpHistory : withdrawalHistory).slice(0, 30).map((w, i) => (
                                        <tr key={i} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors divide-x divide-gray-100 dark:divide-white/5">
                                            <td className="py-4 px-4 whitespace-nowrap text-left font-bold text-gray-900 dark:text-white uppercase text-sm">{w.id}</td>
                                            <td className={`py-4 px-4 whitespace-nowrap text-center font-black uppercase text-sm ${vaultHistoryTab === 'topup' ? 'text-gray-900 dark:text-white' : 'text-green-600 dark:text-green-400'}`}>₹ {w.amount}</td>
                                            <td className="py-4 px-4 whitespace-nowrap">
                                                <div className={`flex items-center justify-center gap-1 font-black uppercase text-sm ${vaultHistoryTab === 'topup' ? 'text-purple-500' : 'text-gray-900 dark:text-white'}`}>
                                                    <span className="text-pink-500 text-base leading-none">🪙</span>{vaultHistoryTab === 'topup' ? w.coins : w.amount}
                                                </div>
                                            </td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center">
                                                <span className={`text-sm font-bold ${w.status === 'SUCCESS' || w.status === 'COMPLETED' ? 'text-green-500' : 'text-yellow-500'}`}>
                                                    {w.status}
                                                </span>
                                            </td>
                                            <td className="py-4 px-4 whitespace-nowrap text-center font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">{w.date}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="5" className="py-8 text-center text-gray-500 dark:text-gray-400 font-bold text-sm uppercase">No {vaultHistoryTab === 'topup' ? 'top-ups' : 'withdrawals'} yet</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </motion.div>
                </div>



            </div>

            {/* MANAGE MY TEAM & ACCOUNTS SECTION */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[5px] md:gap-[15px] mt-[5px] md:mt-[15px] px-[0px] md:px-[15px]">
                {/* MANAGE MY TEAM */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className={`bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none md:rounded-lg p-[5px] md:p-[15px] shadow-sm dark:shadow-none flex flex-col relative overflow-hidden ${isBanned || isAccountInactive ? 'opacity-50 pointer-events-none' : ''}`}
                >
                    <button
                        onClick={(e) => {
                            if (isBanned || isAccountInactive) {
                                e.stopPropagation();
                                return;
                            }
                            handleLftToggle();
                        }}
                        disabled={isBanned || isAccountInactive}
                        className={`absolute top-0 right-0 px-4 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-bl-lg transition-colors z-10 ${isBanned || isAccountInactive ? 'bg-gray-400 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed opacity-50' :
                            lookingForTeam ? 'bg-pink-500 text-white shadow-lg shadow-pink-500/20' : 'bg-gray-200 dark:bg-white/10 text-gray-600 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-white/20'
                            }`}
                    >
                        {isBanned || isAccountInactive ? 'DISABLED' : lookingForTeam ? 'LFT ACTIVE' : 'RECRUIT'}
                    </button>
                    <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                        <svg className="w-6 h-6 text-gray-500 dark:text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                        <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">MANAGE MY TEAM</h3>
                    </div>

                    <div className="flex items-center justify-start xl:justify-center gap-4 sm:gap-6 w-full mt-auto overflow-x-auto pb-4">
                        {/* SQUAD SLOTS (4) */}
                        {['squad-1', 'squad-2', 'squad-3', 'squad-4'].map((slotId, index) => {
                            const tm = myTeammates.find(t => t.slotId === slotId);
                            const roleDisplay = tm?.role || `SLOT ${index + 1}`;
                            return tm ? (
                                <div key={slotId} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                    <div className={`w-24 h-24 rounded-full border-2 border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-[#111] overflow-hidden relative shrink-0 ${index === 0 ? 'border-pink-500' : index === 1 ? 'border-purple-500' : index === 2 ? 'border-blue-500' : 'border-green-500'}`}>
                                        <img src={tm.avatar || `https://i.pravatar.cc/150?u=${tm.uid}`} alt={tm.name} className="w-full h-full object-cover" onError={(e) => { e.target.onerror = null; e.target.src = `https://ui-avatars.com/api/?name=${tm.name}&background=random`; }} />
                                        <div
                                            onClick={() => { setSelectedTeammate(tm); setShowTeammatePopup(true); }}
                                            className="absolute inset-0 bg-black/50 hidden group-hover:flex items-center justify-center cursor-pointer transition-all"
                                        >
                                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
                                        </div>
                                    </div>
                                    <span className="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider truncate max-w-full px-2">{tm.name}</span>
                                </div>
                            ) : (
                                <div key={slotId} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                    <div
                                        onClick={() => { setAddTeammateForm({ slotId, name: '', uid: '', role: 'IGL', kd: '' }); setShowAddTeammatePopup(true); }}
                                        className="w-24 h-24 rounded-full border-2 border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-[#111] flex items-center justify-center cursor-pointer hover:border-pink-500 hover:text-pink-500 transition-colors text-gray-400 dark:text-gray-500 shrink-0"
                                    >
                                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                    </div>
                                    <span className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{roleDisplay}</span>
                                </div>
                            );
                        })}

                        {/* VERTICAL SEPARATOR */}
                        <div className="h-16 w-[2px] bg-gray-200 dark:bg-white/10 shrink-0 self-center mt-2 mx-2"></div>

                        {/* DUO SLOTS (2) */}
                        {['duo-1', 'duo-2'].map((slotId, index) => {
                            const tm = myTeammates.find(t => t.slotId === slotId);
                            const roleDisplay = tm?.role || `DUO ${index + 1}`;
                            return tm ? (
                                <div key={slotId} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                    <div className="w-24 h-24 rounded-full border-2 border-yellow-500 overflow-hidden relative shrink-0">
                                        <img src={tm.avatar || `https://i.pravatar.cc/150?u=${tm.uid}`} alt={tm.name} className="w-full h-full object-cover" onError={(e) => { e.target.onerror = null; e.target.src = `https://ui-avatars.com/api/?name=${tm.name}&background=random`; }} />
                                        <div
                                            onClick={() => { setSelectedTeammate(tm); setShowTeammatePopup(true); }}
                                            className="absolute inset-0 bg-black/50 hidden group-hover:flex items-center justify-center cursor-pointer transition-all"
                                        >
                                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
                                        </div>
                                    </div>
                                    <span className="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider truncate max-w-full px-2">{tm.name}</span>
                                </div>
                            ) : (
                                <div key={slotId} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                    <div
                                        onClick={() => { setAddTeammateForm({ slotId, name: '', uid: '', role: 'IGL', kd: '' }); setShowAddTeammatePopup(true); }}
                                        className="w-24 h-24 rounded-full border-2 border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-[#111] flex items-center justify-center cursor-pointer hover:border-yellow-500 hover:text-yellow-500 transition-colors text-gray-400 dark:text-gray-500 shrink-0"
                                    >
                                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                    </div>
                                    <span className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{roleDisplay}</span>
                                </div>
                            );
                        })}
                    </div>
                </motion.div>

                {/* MANAGE MY ACCOUNTS */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className={`bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none md:rounded-lg p-[5px] md:p-[15px] shadow-sm dark:shadow-none flex flex-col relative overflow-hidden ${isBanned || isAccountInactive ? 'opacity-50 pointer-events-none' : ''}`}
                >
                    <button
                        onClick={() => window.location.hash = '#bgmi-accounts'}
                        className="absolute top-0 right-0 px-4 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-bl-lg transition-colors z-10 bg-gray-200 dark:bg-white/10 text-gray-600 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-white/20"
                    >
                        PURCHASE
                    </button>
                    <div className="flex items-center justify-start md:justify-center gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                        <svg className="w-6 h-6 text-gray-500 dark:text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
                        <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-center w-full md:w-auto">MANAGE MY ACCOUNTS</h3>
                    </div>
                    <div className="flex items-center justify-start xl:justify-center gap-4 sm:gap-6 w-full mt-auto overflow-x-auto pb-4">
                        {/* Display User's Accounts */}
                        {myAccounts.map((acc, idx) => (
                            <div key={acc._id} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                <div
                                    onClick={() => {
                                        setSelectedAccountView(acc);
                                        setCurrentViewPhotoIndex(0);
                                        setShowAccountViewPopup(true);
                                    }}
                                    className="w-24 h-24 rounded-full border-2 border-green-500 bg-gray-50 dark:bg-[#111] flex flex-col items-center justify-center relative shrink-0 overflow-hidden cursor-pointer hover:border-pink-500 transition-colors"
                                >
                                    {acc.images && acc.images.length > 0 ? (
                                        <img src={acc.images[0]} alt="Account" className="w-full h-full object-cover" />
                                    ) : (
                                        <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                                    )}
                                    <div className="absolute inset-0 bg-black/60 hidden group-hover:flex flex-col items-center justify-center transition-all">
                                        <span className="text-[10px] font-bold text-white uppercase mb-1">{acc.status}</span>
                                        <span className="text-[8px] font-bold text-pink-400 uppercase">VIEW</span>
                                    </div>
                                </div>
                                <span className="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider text-center px-1 overflow-hidden text-ellipsis whitespace-nowrap w-24" title={acc.title}>{acc.title || `ACC ${idx + 1}`}</span>
                            </div>
                        ))}

                        {/* Remaining Empty Slots (upto 6 total slots) */}
                        {Array.from({ length: Math.max(0, 6 - myAccounts.length) }).map((_, i) => {
                            const isNextAvailableSlot = i === 0;
                            return (
                                <div key={`empty-${i}`} className="relative group flex flex-col items-center gap-2 min-w-[96px]">
                                    <div
                                        onClick={() => {
                                            if (isNextAvailableSlot) setShowAddAccountPopup(true);
                                        }}
                                        className={`w-24 h-24 rounded-full border-2 border-dashed flex items-center justify-center shrink-0 transition-colors ${isNextAvailableSlot
                                            ? 'border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-[#111] cursor-pointer hover:border-pink-500 hover:text-pink-500 text-gray-400 dark:text-gray-500'
                                            : 'border-gray-200 dark:border-gray-800 bg-gray-100 dark:bg-black/20 text-gray-300 dark:text-gray-700 cursor-not-allowed opacity-50'
                                            }`}
                                    >
                                        {isNextAvailableSlot ? (
                                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                        ) : (
                                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                                        )}
                                    </div>
                                    <span className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                        {isNextAvailableSlot ? `SELL ACC ${myAccounts.length + i + 1}` : `LOCKED`}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </motion.div>
            </div>

            {/* View Account Details Popup */}
            {showAccountViewPopup && selectedAccountView && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white dark:bg-[#1a1a24] p-[15px] rounded-xl border border-gray-200 dark:border-white/10 shadow-2xl max-w-2xl w-full font-['Monda'] uppercase max-h-[90vh] overflow-y-auto"
                    >
                        <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] flex flex-col items-center justify-center relative">
                            <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider leading-tight text-center flex items-center gap-2">
                                {selectedAccountView.title || 'UNKNOWN ACCOUNT'}
                                <span className="text-xs text-gray-400 bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 px-2 py-1 rounded ml-2">#{selectedAccountView.gameUid ? String(selectedAccountView.gameUid).slice(-5) : 'XXXXX'}</span>
                            </h3>
                            <div className="flex items-center gap-3 mt-2">
                                <p className="text-xs text-pink-500 font-bold uppercase tracking-wider text-center">
                                    ACCOUNT LEVEL {selectedAccountView.level || '1'}
                                </p>
                                <span className="w-1 h-1 rounded-full bg-gray-300 dark:bg-gray-600"></span>
                                <p className="text-xs text-pink-500 font-bold uppercase tracking-wider text-center">
                                    COLLECTION LEVEL {selectedAccountView.collectionLevel || '1'}
                                </p>
                                <span className="w-1 h-1 rounded-full bg-gray-300 dark:bg-gray-600"></span>
                                <p className={`text-xs font-bold uppercase tracking-wider text-center ${selectedAccountView.status === 'APPROVED' ? 'text-green-500' : 'text-yellow-500'}`}>
                                    {selectedAccountView.status || 'PENDING'}
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col gap-[15px]">
                            {/* Top: Photo Slider */}
                            {selectedAccountView.images && selectedAccountView.images.length > 0 ? (
                                <div className="relative w-full aspect-video rounded-lg overflow-hidden border border-gray-200 dark:border-white/10 group">
                                    <img src={selectedAccountView.images[currentViewPhotoIndex]} alt="Showcase" className="w-full h-full object-cover absolute inset-0" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none"></div>

                                    {selectedAccountView.images.length > 1 && (
                                        <>
                                            <button onClick={prevViewPhoto} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-pink-500 z-10">
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                                            </button>
                                            <button onClick={nextViewPhoto} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-pink-500 z-10">
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                                            </button>

                                            <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-10">
                                                {selectedAccountView.images.map((_, i) => (
                                                    <div key={i} className={`h-1.5 rounded-full transition-all ${i === currentViewPhotoIndex ? 'w-6 bg-pink-500' : 'w-2 bg-white/50'}`}></div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div className="relative w-full aspect-video rounded-lg bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 flex items-center justify-center">
                                    <span className="text-gray-400 font-bold">NO PHOTOS</span>
                                </div>
                            )}

                            {/* Bottom: Details & Actions */}
                            <div className="flex flex-col mt-[15px]">

                                <div className="grid grid-cols-2 gap-[15px] mb-[15px] text-sm">
                                    <div className="bg-gray-50 dark:bg-black/50 p-3 rounded-lg border border-gray-200 dark:border-white/10">
                                        <span className="text-gray-500 dark:text-gray-400 text-xs block mb-1 uppercase font-bold">Price</span>
                                        <span className="font-bold text-green-600 dark:text-green-400 text-lg leading-none">₹ {selectedAccountView.price || '0'}</span>
                                    </div>
                                    <div className="bg-gray-50 dark:bg-black/50 p-3 rounded-lg border border-gray-200 dark:border-white/10">
                                        <span className="text-gray-500 dark:text-gray-400 text-xs block mb-1 uppercase font-bold">UC Balance</span>
                                        <span className="font-bold text-purple-600 dark:text-purple-400 leading-none">{selectedAccountView.ucBalance || '0'}</span>
                                    </div>
                                    <div className="bg-gray-50 dark:bg-black/50 p-3 rounded-lg border border-gray-200 dark:border-white/10">
                                        <span className="text-gray-500 dark:text-gray-400 text-xs block mb-1 uppercase font-bold">Royal Pass</span>
                                        <span className="font-bold leading-none">{selectedAccountView.royalPass || 'N/A'}</span>
                                    </div>
                                    <div className="bg-gray-50 dark:bg-black/50 p-3 rounded-lg border border-gray-200 dark:border-white/10">
                                        <span className="text-gray-500 dark:text-gray-400 text-xs block mb-1 uppercase font-bold">Rank</span>
                                        <span className="font-bold text-pink-600 dark:text-pink-400 leading-none">{selectedAccountView.rank || 'Bronze'}</span>
                                    </div>
                                </div>

                                <div className="flex gap-[15px] mt-auto">
                                    <button
                                        onClick={() => setShowAccountViewPopup(false)}
                                        className="w-full px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                                    >
                                        CLOSE DETAILS
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}

            {/* 9. SETTINGS SECTION */}
            <div className="grid grid-cols-1 mt-[5px] md:mt-[15px] px-[0px] md:px-[15px]">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-none md:rounded-lg p-[5px] md:p-[15px] shadow-sm dark:shadow-none flex flex-col"
                >
                    <div className="flex items-center justify-start md:justify-start gap-3 mb-[5px] md:mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[10px] md:pb-[15px] w-full">
                        <svg className="w-6 h-6 text-gray-500 dark:text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                        <h3 className="font-['Monda'] text-lg md:text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider text-left md:text-left w-full md:w-auto">SETTINGS</h3>
                    </div>

                    <div className="flex flex-col gap-3">
                        <div className="bg-gray-50 dark:bg-[#111] p-[15px] rounded-lg border border-gray-200 dark:border-white/5 flex items-center justify-between">
                            <div>
                                <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-1">NOTIFICATIONS</h4>
                                <p className="text-xs text-gray-500 dark:text-gray-400">Receive match reminders and updates</p>
                            </div>
                            <button className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none bg-pink-500">
                                <span className="translate-x-6 inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
                            </button>
                        </div>

                        <div className="bg-gray-50 dark:bg-[#111] p-[15px] rounded-lg border border-gray-200 dark:border-white/5 flex items-center justify-between">
                            <div>
                                <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-1">AUTO-ACCEPT INVITES</h4>
                                <p className="text-xs text-gray-500 dark:text-gray-400">Automatically accept team invites from friends</p>
                            </div>
                            <button className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none bg-gray-300 dark:bg-gray-700">
                                <span className="translate-x-1 inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
                            </button>
                        </div>

                        <div className="bg-gray-50 dark:bg-[#111] p-[15px] rounded-lg border border-gray-200 dark:border-white/5 flex items-center justify-between">
                            <div>
                                <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-1">PRIVATE PROFILE</h4>
                                <p className="text-xs text-gray-500 dark:text-gray-400">Hide your profile from public searches</p>
                            </div>
                            <button className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none bg-gray-300 dark:bg-gray-700">
                                <span className="translate-x-1 inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
                            </button>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* LFT POPUP */}
            <AnimatePresence>
                {showLftPopup && (
                    <div
                        className="fixed inset-0 z-[99999] flex items-end md:items-center justify-center p-0 md:p-4 bg-black/60 backdrop-blur-sm"
                        onClick={() => { setShowLftPopup(false); setLookingForTeam(false); }}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: "100%" }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: "100%" }}
                            transition={{ type: "spring", damping: 25, stiffness: 200 }}
                            className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl w-full md:max-w-sm font-['Monda'] uppercase pb-10 md:pb-[15px]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Drag Handle for Mobile */}
                            <div className="w-12 h-1.5 bg-gray-300 dark:bg-white/20 rounded-full mx-auto mb-4 md:hidden"></div>
                            <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                                <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">MATCHING PREFERENCES</h3>
                            </div>

                            <div className="grid grid-cols-2 gap-[15px] mb-4">
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">LOOKING FOR ROLE</label>
                                    <div className="relative">
                                        <div
                                            onClick={() => {
                                                setIsRoleDropdownOpen(!isRoleDropdownOpen);
                                                setIsTypeDropdownOpen(false);
                                            }}
                                            className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase text-center cursor-pointer select-none"
                                        >
                                            {lftDetails.role || "SELECT"}
                                        </div>
                                        {isRoleDropdownOpen && (
                                            <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-[#1a1a24] border border-gray-200 dark:border-white/10 rounded-lg shadow-xl overflow-hidden z-50 py-1">
                                                {["IGL", "Sniper", "Camper", "Support", "Assaulter"].map((role) => (
                                                    <div
                                                        key={role}
                                                        onClick={() => {
                                                            setLftDetails({ ...lftDetails, role });
                                                            setIsRoleDropdownOpen(false);
                                                        }}
                                                        className="px-4 py-2 font-black text-center text-gray-900 dark:text-white hover:bg-pink-500 hover:text-white dark:hover:bg-pink-500 cursor-pointer uppercase transition-colors"
                                                    >
                                                        {role}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">LOOKING FOR TEAM</label>
                                    <div className="relative">
                                        <div
                                            onClick={() => {
                                                setIsTypeDropdownOpen(!isTypeDropdownOpen);
                                                setIsRoleDropdownOpen(false);
                                            }}
                                            className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase text-center cursor-pointer select-none"
                                        >
                                            {lftDetails.type || "SELECT"}
                                        </div>
                                        {isTypeDropdownOpen && (
                                            <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-[#1a1a24] border border-gray-200 dark:border-white/10 rounded-lg shadow-xl overflow-hidden z-50 py-1">
                                                {["DUO", "SQUAD"].map((type) => (
                                                    <div
                                                        key={type}
                                                        onClick={() => {
                                                            setLftDetails({ ...lftDetails, type });
                                                            setIsTypeDropdownOpen(false);
                                                        }}
                                                        className="px-4 py-2 font-black text-center text-gray-900 dark:text-white hover:bg-pink-500 hover:text-white dark:hover:bg-pink-500 cursor-pointer uppercase transition-colors"
                                                    >
                                                        {type}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="mb-6">
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">MY F/D RATIO</label>
                                <input
                                    type="number"
                                    step="0.1"
                                    value={lftDetails.kd}
                                    onChange={(e) => setLftDetails({ ...lftDetails, kd: e.target.value })}
                                    placeholder="E.G. 4.5"
                                    className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase text-center placeholder:text-left [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                />
                            </div>

                            <div className="flex gap-[15px]">
                                <button
                                    onClick={() => { setShowLftPopup(false); setLookingForTeam(false); }}
                                    className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                                >
                                    CANCEL
                                </button>
                                <button
                                    onClick={submitLft}
                                    disabled={!lftDetails.role || !lftDetails.kd || !lftDetails.type}
                                    className="flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    ENABLE
                                </button>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
            {/* Add New ID Popup */}
            {showAddIdPopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white dark:bg-[#1a1a24] p-[15px] rounded-xl border border-gray-200 dark:border-white/10 shadow-2xl max-w-sm w-full font-['Monda']"
                    >
                        <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                            <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">ADD NEW BGMI ID</h3>
                        </div>

                        <div className="mb-4">
                            <label className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2 block">ENTER BGMI UID</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={newUid}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, '');
                                    setNewUid(val);
                                    setFetchSuccess(false);
                                    setNewIgn("");
                                }}
                                className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                placeholder="E.G. 5123456789"
                            />
                        </div>

                        <div className="mb-6 relative">
                            <label className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2 block">IN-GAME NAME (IGN)</label>
                            <div className="relative w-full">
                                {isFetchingUid && (
                                    <div className="absolute inset-0 bg-gray-200 dark:bg-white/10 animate-pulse rounded-lg z-10 pointer-events-none"></div>
                                )}
                                <input
                                    type="text"
                                    value={newIgn}
                                    onChange={(e) => setNewIgn(e.target.value)}
                                    readOnly={fetchFailCount < 2 && !fetchSuccess}
                                    className={`w-full font-black text-lg bg-gray-50 dark:bg-black/50 border rounded-lg px-4 py-3 focus:outline-none transition-colors dark:text-white uppercase ${fetchSuccess ? 'border-green-500 focus:border-green-500' :
                                        fetchFailCount >= 2 ? 'border-pink-500 focus:border-pink-500' : 'border-gray-300 dark:border-white/10'
                                        } ${fetchFailCount < 2 && !fetchSuccess ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    placeholder={fetchFailCount >= 2 ? "ENTER NAME MANUALLY" : "WAITING FOR FETCH..."}
                                />
                            </div>
                        </div>

                        {fetchError && <p className="text-red-500 text-xs font-bold mb-4 uppercase">{fetchError}</p>}
                        {fetchFailCount >= 2 && !fetchSuccess && (
                            <p className="text-yellow-600 dark:text-yellow-500 text-xs font-bold mb-4 uppercase">MANUAL ENTRY ENABLED AFTER 2 FAILED ATTEMPTS.</p>
                        )}

                        <div className="flex gap-[15px]">
                            <button
                                onClick={closePopup}
                                className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                            >
                                CANCEL
                            </button>
                            {(fetchSuccess || fetchFailCount >= 2) ? (
                                <button
                                    onClick={handleSaveId}
                                    disabled={!newUid || !newIgn || isSavingUid}
                                    className={`flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg transition-colors flex justify-center items-center gap-2 ${isSavingUid ? 'opacity-70 cursor-not-allowed' : 'hover:bg-pink-600 disabled:opacity-50 disabled:cursor-not-allowed'}`}
                                >
                                    {isSavingUid ? (
                                        <>
                                            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            SAVING...
                                        </>
                                    ) : (
                                        "SAVE ID"
                                    )}
                                </button>
                            ) : (
                                <button
                                    onClick={handleFetchUid}
                                    disabled={isFetchingUid || !newUid}
                                    className="flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center"
                                >
                                    {isFetchingUid ? (
                                        <span className="w-5 h-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"></span>
                                    ) : "FETCH"}
                                </button>
                            )}
                        </div>
                    </motion.div>
                </div>
            )}

            {/* Transfer Popup */}
            <AnimatePresence>
                {showTransferModal && (
                    <div
                        className="fixed inset-0 z-[99999] flex items-end md:items-center justify-center p-0 md:p-4 bg-black/60 backdrop-blur-sm"
                        onClick={() => setShowTransferModal(false)}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: "100%" }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: "100%" }}
                            transition={{ type: "spring", damping: 25, stiffness: 200 }}
                            className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl max-w-full md:max-w-sm w-full font-['Monda'] pb-10 md:pb-[15px]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h3 className="text-lg font-black text-gray-900 dark:text-white uppercase mb-4 text-center">TRANSFER GLPC</h3>

                            {!targetPlayerInfo ? (
                                <div className="space-y-4">
                                    <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">SELECT FRIEND TO TRANSFER</label>
                                    <div className="max-h-60 overflow-y-auto space-y-2 pr-1 custom-scrollbar">
                                        {resolvedFriendsList.length > 0 ? resolvedFriendsList.map((friend) => (
                                            <div key={friend.id} className="flex items-center justify-between bg-gray-100 dark:bg-[#0a0a0f] p-2 rounded-lg border border-gray-200 dark:border-white/5">
                                                <div className="flex items-center gap-3">
                                                    <img src={friend.resolvedAvatar} alt="avatar" className="w-8 h-8 rounded-full border border-gray-300 dark:border-white/10" />
                                                    <div>
                                                        <p className="text-sm font-black text-gray-900 dark:text-white uppercase">{friend.resolvedName}</p>
                                                        <p className="text-[10px] font-bold text-orange-500">{friend.resolvedUid}</p>
                                                    </div>
                                                </div>
                                                {friend.isBanned || friend.isInactive ? (
                                                    <button
                                                        disabled
                                                        className="px-3 py-1.5 bg-gray-500 text-white font-bold text-xs uppercase rounded opacity-50 cursor-not-allowed shadow-sm"
                                                    >
                                                        BANNED
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={() => setTargetPlayerInfo({ name: friend.resolvedName, playerId: friend.resolvedUid, uid: friend.senderId === (gamerUser?.uid || gamerUser?.gamerCode) ? friend.receiverId : friend.senderId })}
                                                        className="px-3 py-1.5 bg-gradient-to-r from-orange-400 to-red-500 text-white font-bold text-xs uppercase rounded hover:from-orange-500 hover:to-red-600 transition-all shadow-sm"
                                                    >
                                                        TRANSFER
                                                    </button>
                                                )}
                                            </div>
                                        )) : (
                                            <p className="text-center text-gray-500 dark:text-gray-400 text-sm font-bold uppercase py-4">NO FRIENDS FOUND</p>
                                        )}
                                    </div>
                                    <div className="flex gap-3">
                                        <button
                                            onClick={() => setShowTransferModal(false)}
                                            className="w-full px-4 py-3 bg-gray-200 dark:bg-white/10 text-gray-700 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-300 dark:hover:bg-white/20 transition-colors"
                                        >
                                            CANCEL
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="space-y-4">
                                    <div className="bg-gray-100 dark:bg-[#0a0a0f] p-3 rounded-lg border border-gray-200 dark:border-white/5">
                                        <p className="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">TRANSFER TO</p>
                                        <p className="text-sm font-black text-gray-900 dark:text-white">{targetPlayerInfo.name}</p>
                                        <p className="text-xs font-bold text-orange-500">{targetPlayerInfo.playerId}</p>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">GLPC TO TRANSFER</label>
                                        <div className="flex gap-2">
                                            <input
                                                type="number"
                                                value={transferAmountGLPC}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\D/g, '');
                                                    setTransferAmountGLPC(val);
                                                }}
                                                placeholder="GLPC"
                                                className="w-1/2 bg-gray-100 dark:bg-[#0a0a0f] border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-600 focus:outline-none focus:border-orange-500 font-bold uppercase transition-colors"
                                            />
                                            <div className="w-1/2 bg-gray-100 dark:bg-[#0a0a0f] border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 flex items-center justify-center font-bold text-green-500">
                                                ₹ {transferAmountGLPC ? (parseInt(transferAmountGLPC) * 1.25).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                            </div>
                                        </div>
                                        <p className="text-[10px] text-gray-500 font-semibold mt-2">AVAILABLE: <span className="text-pink-500">🪙 {eCoinsBalance}</span></p>
                                    </div>
                                    <div className="flex gap-3 mt-4">
                                        <button
                                            onClick={() => { setTargetPlayerInfo(null); setTransferAmountGLPC(''); }}
                                            className="flex-1 px-4 py-3 bg-gray-200 dark:bg-white/10 text-gray-700 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-300 dark:hover:bg-white/20 transition-colors"
                                        >
                                            BACK
                                        </button>
                                        <button
                                            onClick={handleTransfer}
                                            disabled={isTransferring || !transferAmountGLPC || parseInt(transferAmountGLPC) <= 0 || parseInt(transferAmountGLPC) > eCoinsBalance}
                                            className="flex-1 px-4 py-3 bg-gradient-to-r from-orange-400 to-red-500 text-white font-bold text-sm uppercase rounded-lg hover:from-orange-500 hover:to-red-600 transition-all shadow-md shadow-orange-500/20 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center"
                                        >
                                            {isTransferring ? (
                                                <span className="w-5 h-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"></span>
                                            ) : "TRANSFER"}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            {/* Cashout Popup */}
            <AnimatePresence>
                {showCashoutPopup && (
                    <div
                        className="fixed inset-0 z-[99999] flex items-end md:items-center justify-center p-0 md:p-4 bg-black/60 backdrop-blur-sm"
                        onClick={() => setShowCashoutPopup(false)}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: "100%" }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: "100%" }}
                            transition={{ type: "spring", damping: 25, stiffness: 200 }}
                            className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl max-w-full md:max-w-sm w-full font-['Monda'] pb-10 md:pb-[15px]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Drag Handle for Mobile */}
                            <div className="w-12 h-1.5 bg-gray-300 dark:bg-white/20 rounded-full mx-auto mb-4 md:hidden"></div>
                            <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                                <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">WITHDRAW AMOUNT</h3>
                            </div>

                            <div className="mb-4 bg-gray-50 dark:bg-black/50 p-4 rounded-lg border border-gray-200 dark:border-white/10 flex justify-between items-center">
                                <span className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">REDEEMABLE BALANCE</span>
                                <span className="font-black text-green-500">₹ {redeemableINR.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</span>
                            </div>

                            <div className="grid grid-cols-2 gap-[15px] mb-6">
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2 block">ENTER AMOUNT</label>
                                    <input
                                        type="number"
                                        value={withdrawAmount}
                                        onChange={(e) => setWithdrawAmount(e.target.value)}
                                        className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                        placeholder="MIN 300"
                                        min="300"
                                        max={redeemableINR}
                                    />
                                </div>
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2 block">-2% PLATFORM FEE</label>
                                    <div className="w-full bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 flex flex-col justify-center" style={{ minHeight: '54px' }}>
                                        <span className={`font-black text-lg leading-none ${withdrawAmount && parseInt(withdrawAmount) >= 300 && parseInt(withdrawAmount) <= redeemableINR ? 'text-green-500' : 'text-gray-400 dark:text-gray-600'}`}>
                                            {withdrawAmount && parseInt(withdrawAmount) >= 300 && parseInt(withdrawAmount) <= redeemableINR
                                                ? `₹ ${(parseInt(withdrawAmount) * 0.98).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`
                                                : "₹ 0"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-[15px]">
                                <button
                                    onClick={() => setShowCashoutPopup(false)}
                                    className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                                >
                                    CANCEL
                                </button>
                                <button
                                    onClick={handleWithdrawSubmit}
                                    disabled={!withdrawAmount || parseInt(withdrawAmount) < 300 || parseInt(withdrawAmount) > redeemableINR}
                                    className="flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    SUBMIT
                                </button>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
            {/* Teammate Popup */}
            {showTeammatePopup && selectedTeammate && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white dark:bg-[#1a1a24] p-[15px] rounded-xl border border-gray-200 dark:border-white/10 shadow-2xl max-w-sm w-full font-['Monda'] uppercase relative"
                    >
                        <button onClick={() => setShowTeammatePopup(false)} className="absolute top-[15px] right-[15px] text-gray-400 hover:text-pink-500 transition-colors z-10">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                            <h3 className="font-['Monda'] text-2xl font-black text-gray-900 dark:text-white uppercase tracking-wider">{selectedTeammate.uid || 'N/A'}</h3>
                        </div>

                        <div className="space-y-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">IN-GAME NAME</label>
                                <div className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 dark:text-white text-center">
                                    {selectedTeammate.name || 'UNKNOWN'}
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-[15px]">
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">ROLE</label>
                                    <div className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 dark:text-white text-center">
                                        {selectedTeammate.role || 'N/A'}
                                    </div>
                                </div>
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">K/D RATIO</label>
                                    <div className="w-full font-black text-lg bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 dark:text-white text-center">
                                        {selectedTeammate.kd || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-[15px]">
                            <button
                                onClick={() => setShowTeammatePopup(false)}
                                className="flex-1 py-3 rounded-lg bg-gray-200 dark:bg-white/5 text-gray-900 dark:text-white font-bold hover:bg-gray-300 dark:hover:bg-white/10 transition-colors"
                            >
                                CANCEL
                            </button>
                            <button
                                onClick={async () => {
                                    setIsSavingTeammate(true);
                                    try {
                                        await deleteDoc(doc(db, 'findTeammates', selectedTeammate._id));
                                        setShowTeammatePopup(false);
                                    } catch (e) {
                                        console.error(e);
                                    }
                                    setIsSavingTeammate(false);
                                }}
                                disabled={isSavingTeammate}
                                className="flex-1 py-3 rounded-lg bg-pink-500 hover:bg-pink-600 text-white font-black transition-colors disabled:opacity-50 flex justify-center items-center"
                            >
                                {isSavingTeammate ? (
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                ) : 'REMOVE'}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
            {/* Add Account Popup */}
            {showAddAccountPopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-[15px] bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white dark:bg-[#1a1a24] p-[15px] rounded-xl border border-gray-200 dark:border-white/10 shadow-2xl max-w-md w-full font-['Monda'] uppercase max-h-[90vh] overflow-y-auto"
                    >
                        <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                            <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">ADD ACCOUNT TO SELL</h3>
                        </div>

                        <div className="grid grid-cols-2 gap-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">ACCOUNT NAME</label>
                                <input
                                    type="text"
                                    value={accountForm.title}
                                    onChange={(e) => setAccountForm({ ...accountForm, title: e.target.value })}
                                    placeholder="MYTHIC FASHION MAX"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">GAME UID</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.gameUid}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/[^0-9]/g, '');
                                        setAccountForm({ ...accountForm, gameUid: val });
                                    }}
                                    placeholder="5123456789"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">ACCOUNT LEVEL</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.level}
                                    onChange={(e) => {
                                        let val = e.target.value.replace(/[^0-9]/g, '');
                                        if (val !== '') {
                                            let num = parseInt(val, 10);
                                            if (num > 100) val = '100';
                                            if (num === 0) val = '1';
                                        }
                                        setAccountForm({ ...accountForm, level: val });
                                    }}
                                    placeholder="75"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">COLLECTION LEVEL</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.collectionLevel}
                                    onChange={(e) => {
                                        let val = e.target.value.replace(/[^0-9]/g, '');
                                        if (val !== '') {
                                            let num = parseInt(val, 10);
                                            if (num > 100) val = '100';
                                            if (num === 0) val = '1';
                                        }
                                        setAccountForm({ ...accountForm, collectionLevel: val });
                                    }}
                                    placeholder="50"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">RANK</label>
                                <div className="relative">
                                    <div
                                        onClick={() => setIsRankDropdownOpen(!isRankDropdownOpen)}
                                        className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase text-left cursor-pointer select-none"
                                    >
                                        {selectedRank || "SELECT"}
                                    </div>
                                    {isRankDropdownOpen && (
                                        <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-[#1a1a24] border border-gray-200 dark:border-white/10 rounded-lg shadow-xl overflow-hidden z-50 py-1 max-h-48 overflow-y-auto">
                                            {["Bronze", "Silver", "Gold", "Platinum", "Diamond", "Crown", "Ace", "Ace Master", "Ace Dominator", "Conqueror"].map((rank) => (
                                                <div
                                                    key={rank}
                                                    onClick={() => {
                                                        setSelectedRank(rank);
                                                        setIsRankDropdownOpen(false);
                                                    }}
                                                    className="px-4 py-2 text-sm font-bold text-gray-700 dark:text-gray-300 hover:bg-pink-50 dark:hover:bg-pink-500/10 hover:text-pink-500 cursor-pointer uppercase transition-colors"
                                                >
                                                    {rank}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">ROYAL PASS</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.royalPass}
                                    onChange={(e) => {
                                        let val = e.target.value.replace(/[^0-9]/g, '');
                                        if (val !== '') {
                                            if (parseInt(val, 10) > 100) val = '100';
                                        }
                                        setAccountForm({ ...accountForm, royalPass: val });
                                    }}
                                    placeholder="100"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                        </div>

                        <div className="mb-[15px]">
                            <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">3 SCREENSHOTS</label>
                            <div className="grid grid-cols-3 gap-[15px]">
                                {[0, 1, 2].map(i => (
                                    <React.Fragment key={i}>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id={`account-image-${i}`}
                                            className="hidden"
                                            onChange={(e) => {
                                                if (e.target.files[0]) {
                                                    const newImages = [...accountImages];
                                                    newImages[i] = e.target.files[0];
                                                    setAccountImages(newImages);
                                                }
                                            }}
                                        />
                                        <div
                                            onClick={() => document.getElementById(`account-image-${i}`).click()}
                                            className="aspect-square rounded-lg border-2 border-dashed border-gray-300 dark:border-white/20 flex flex-col items-center justify-center cursor-pointer hover:border-pink-500 transition-colors text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-black/50 relative overflow-hidden"
                                        >
                                            {accountImages[i] ? (
                                                <img src={URL.createObjectURL(accountImages[i])} alt={`Upload ${i}`} className="w-full h-full object-cover" />
                                            ) : (
                                                <>
                                                    <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                                    <span className="text-[10px] font-bold">ADD</span>
                                                </>
                                            )}
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">PRICE (₹)</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.price}
                                    onChange={(e) => {
                                        let val = e.target.value.replace(/[^0-9]/g, '');
                                        if (val !== '' && parseInt(val, 10) > 1000000) val = '1000000';
                                        setAccountForm({ ...accountForm, price: val });
                                    }}
                                    placeholder="10000"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">UC BALANCE</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={accountForm.ucBalance}
                                    onChange={(e) => {
                                        let val = e.target.value.replace(/[^0-9]/g, '');
                                        if (val !== '' && parseInt(val, 10) > 1000000) val = '1000000';
                                        setAccountForm({ ...accountForm, ucBalance: val });
                                    }}
                                    placeholder="1200"
                                    className="w-full font-black text-sm bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white uppercase"
                                />
                            </div>
                        </div>

                        <div className="flex gap-[15px]">
                            <button
                                onClick={() => setShowAddAccountPopup(false)}
                                className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                            >
                                CANCEL
                            </button>
                            <button
                                onClick={handleListAccount}
                                disabled={isListingAccount}
                                className={`flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg transition-colors flex justify-center items-center gap-2 ${isListingAccount ? 'opacity-50 cursor-not-allowed' : 'hover:bg-pink-600'}`}
                            >
                                {isListingAccount ? (
                                    <>
                                        <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        PROCESSING...
                                    </>
                                ) : "LIST FOR SALE"}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
            {showEditProfilePopup && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-0 md:p-[15px] bg-black/80 backdrop-blur-sm"
                    onClick={() => setShowEditProfilePopup(false)}
                >
                    <motion.div
                        initial={{ opacity: 0, y: typeof window !== 'undefined' && window.innerWidth < 768 ? "100%" : 0, scale: typeof window !== 'undefined' && window.innerWidth >= 768 ? 0.95 : 1 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: typeof window !== 'undefined' && window.innerWidth < 768 ? "100%" : 0, scale: typeof window !== 'undefined' && window.innerWidth >= 768 ? 0.95 : 1 }}
                        transition={{ type: "spring", damping: 25, stiffness: 200 }}
                        className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl w-full max-w-full md:max-w-md font-['Monda'] relative pb-10 md:pb-[15px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Mobile Drag Handle */}
                        <div className="w-12 h-1.5 bg-gray-300 dark:bg-white/20 rounded-full mx-auto mb-4 md:hidden"></div>
                        <button onClick={() => setShowEditProfilePopup(false)} className="hidden md:block absolute top-[15px] right-[15px] text-gray-400 hover:text-pink-500 transition-colors">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>

                        <div className="mb-[15px] border-b border-gray-200 dark:border-white/10 pb-[15px]">
                            <h3 className="text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">EDIT PROFILE</h3>
                        </div>

                        <div className="space-y-[15px] mb-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">NAME</label>
                                <input
                                    type="text"
                                    value={editProfileData.name}
                                    onChange={e => setEditProfileData({ ...editProfileData, name: e.target.value })}
                                    className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">STATE</label>
                                <input
                                    type="text"
                                    value={editProfileData.state}
                                    onChange={e => setEditProfileData({ ...editProfileData, state: e.target.value })}
                                    className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">MOBILE</label>
                                <input
                                    type="text"
                                    value={editProfileData.mobile}
                                    onChange={e => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                        setEditProfileData({ ...editProfileData, mobile: val });
                                    }}
                                    className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white"
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">UPI ID</label>
                                <input
                                    type="text"
                                    value={editProfileData.upiId}
                                    onChange={e => setEditProfileData({ ...editProfileData, upiId: e.target.value })}
                                    className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white"
                                />
                            </div>
                        </div>

                        <div className="flex gap-[15px]">
                            <button
                                onClick={() => setShowEditProfilePopup(false)}
                                className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                            >
                                CANCEL
                            </button>
                            <button
                                onClick={async () => {
                                    setIsSavingProfile(true);

                                    // Check uniqueness for MOBILE and UPI ID
                                    if (editProfileData.mobile || editProfileData.upiId) {
                                        const usersRef = collection(db, 'users');
                                        const qSnap = await getDocs(usersRef);
                                        let isMobileDup = false;
                                        let isUpiDup = false;

                                        qSnap.forEach(docSnap => {
                                            if (docSnap.id !== (gamerUser?.uid || gamerUser?.gamerCode)) {
                                                const d = docSnap.data();
                                                if (editProfileData.mobile && (d.mobile === editProfileData.mobile || d.profileData?.mobile === editProfileData.mobile)) isMobileDup = true;
                                                if (editProfileData.upiId && editProfileData.upiId.trim() !== '' && (d.upiId === editProfileData.upiId || d.profileData?.upiId === editProfileData.upiId)) isUpiDup = true;
                                            }
                                        });

                                        if (isMobileDup) {
                                            setNotification("MOBILE NUMBER ALREADY IN USE!");
                                            setTimeout(() => setNotification(null), 5000);
                                            setIsSavingProfile(false);
                                            return;
                                        }
                                        if (isUpiDup) {
                                            setNotification("UPI ID ALREADY IN USE!");
                                            setTimeout(() => setNotification(null), 5000);
                                            setIsSavingProfile(false);
                                            return;
                                        }
                                    }

                                    editProfileData.lastProfileUpdate = Date.now();

                                    const updatePromise = updateProfileData ? updateProfileData(editProfileData) : Promise.resolve();
                                    const timerPromise = new Promise(resolve => setTimeout(resolve, 2000));

                                    await Promise.all([updatePromise, timerPromise]);

                                    setProfile({ ...profile, ...editProfileData });
                                    setIsSavingProfile(false);
                                    setShowEditProfilePopup(false);
                                }}
                                disabled={isSavingProfile || profileLockTimeLeft !== null}
                                className={`flex-1 px-4 py-3 bg-pink-500 text-white font-bold text-sm uppercase rounded-lg transition-colors flex items-center justify-center gap-2 ${(isSavingProfile || profileLockTimeLeft !== null) ? 'opacity-70 cursor-not-allowed' : 'hover:bg-pink-600'}`}
                            >
                                {isSavingProfile ? (
                                    <>
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        SAVING...
                                    </>
                                ) : profileLockTimeLeft !== null ? (
                                    `LOCKED FOR ${profileLockTimeLeft}`
                                ) : (
                                    'SAVE CHANGES'
                                )}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}

            {/* TOP UP POPUP */}
            <AnimatePresence>
                {showTopUpPopup && (
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[99999] flex items-end md:items-center justify-center p-0 md:p-[15px]"
                        onClick={() => { setShowTopUpPopup(false); setSelectedTopUp(null); }}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: "100%" }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: "100%" }}
                            transition={{ type: "spring", damping: 25, stiffness: 200 }}
                            className="bg-white dark:bg-[#1a1a24] p-[20px] md:p-[15px] rounded-t-3xl md:rounded-xl md:rounded-b-xl border-t border-gray-200 dark:border-white/10 md:border shadow-[0_-10px_40px_rgba(0,0,0,0.3)] md:shadow-2xl w-full max-w-full md:max-w-md font-['Monda'] relative pb-10 md:pb-[15px]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Drag Handle for Mobile */}
                            <div className="w-12 h-1.5 bg-gray-300 dark:bg-white/20 rounded-full mx-auto mb-4 md:hidden"></div>
                            <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                                <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">TOP-UP GLPC WALLET</h3>
                            </div>

                            <div className="grid grid-cols-2 gap-[15px] mb-[15px]">
                                {[
                                    { coins: 80, price: "₹ 100", theme: "slate" },
                                    { coins: 160, price: "₹ 200", bonus: "+16", bonusDisplay: "+1 ENTRY", theme: "cyan" },
                                    { coins: 240, price: "₹ 300", bonus: "+32", bonusDisplay: "+2 ENTRY", theme: "emerald" },
                                    { coins: 400, price: "₹ 500", bonus: "+64", bonusDisplay: "+4 ENTRY", theme: "blue" },
                                    { coins: 800, price: "₹ 1000", bonus: "+160", bonusDisplay: "+10 ENTRY", theme: "purple" },
                                    { coins: 1600, price: "₹ 2000", bonus: "+352", bonusDisplay: "+22 ENTRY", theme: "rose" }
                                ].map((pkg, i) => {
                                    const themeStyles = {
                                        slate: { top: "bg-slate-50 dark:bg-slate-900/40 text-slate-700 dark:text-slate-300", bottomL: "bg-slate-100 dark:bg-slate-800/60 text-slate-500", bottomR: "bg-slate-200/50 dark:bg-slate-700/40 text-slate-800 dark:text-slate-200" },
                                        cyan: { top: "bg-cyan-50 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300", bottomL: "bg-cyan-100 dark:bg-cyan-800/60 text-cyan-600 dark:text-cyan-400", bottomR: "bg-cyan-200/50 dark:bg-cyan-700/40 text-cyan-900 dark:text-cyan-100" },
                                        emerald: { top: "bg-emerald-50 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300", bottomL: "bg-emerald-100 dark:bg-emerald-800/60 text-emerald-600 dark:text-emerald-400", bottomR: "bg-emerald-200/50 dark:bg-emerald-700/40 text-emerald-900 dark:text-emerald-100" },
                                        blue: { top: "bg-blue-50 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300", bottomL: "bg-blue-100 dark:bg-blue-800/60 text-blue-600 dark:text-blue-400", bottomR: "bg-blue-200/50 dark:bg-blue-700/40 text-blue-900 dark:text-blue-100" },
                                        purple: { top: "bg-purple-50 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300", bottomL: "bg-purple-100 dark:bg-purple-800/60 text-purple-600 dark:text-purple-400", bottomR: "bg-purple-200/50 dark:bg-purple-700/40 text-purple-900 dark:text-purple-100" },
                                        rose: { top: "bg-rose-50 dark:bg-rose-900/40 text-rose-700 dark:text-rose-300", bottomL: "bg-rose-100 dark:bg-rose-800/60 text-rose-600 dark:text-rose-400", bottomR: "bg-rose-200/50 dark:bg-rose-700/40 text-rose-900 dark:text-rose-100" }
                                    };
                                    const s = themeStyles[pkg.theme];

                                    return (
                                        <div
                                            key={i}
                                            onClick={() => setSelectedTopUp(pkg)}
                                            className={`h-24 rounded-lg border-2 cursor-pointer transition-all duration-200 overflow-hidden flex flex-col ${selectedTopUp?.coins === pkg.coins ? 'border-purple-500 scale-[1.02] z-10' : 'border-gray-200 dark:border-white/10 hover:border-purple-500/50'}`}
                                        >
                                            <div className="grid grid-cols-2 grid-rows-2 h-full w-full gap-[1px] bg-gray-200 dark:bg-white/10">

                                                {/* Top Row: Coins (Spans 2 cols) */}
                                                <div className={`col-span-2 flex items-center justify-center ${s.top} ${selectedTopUp?.coins === pkg.coins ? 'brightness-125' : ''}`}>
                                                    <span className="text-[32px] font-black leading-none tracking-tight flex items-baseline gap-1.5">
                                                        {pkg.coins} <span className="text-[14px] font-bold opacity-80 tracking-widest">GLPC</span>
                                                    </span>
                                                </div>

                                                {/* Bottom Left: Bonus */}
                                                <div className={`flex items-center justify-center ${s.bottomL} ${selectedTopUp?.coins === pkg.coins ? 'brightness-110' : ''}`}>
                                                    {pkg.bonus ? (
                                                        <span className="text-sm font-['Monda'] font-black uppercase">
                                                            {pkg.bonusDisplay || pkg.bonus}
                                                        </span>
                                                    ) : (
                                                        <span className="text-xl font-black leading-none opacity-50">
                                                            -
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Bottom Right: Price */}
                                                <div className={`flex items-center justify-center ${s.bottomR} ${selectedTopUp?.coins === pkg.coins ? 'brightness-110' : ''}`}>
                                                    <span className="text-sm font-['Monda'] font-black uppercase tracking-wider">
                                                        {pkg.price}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="flex gap-[15px]">
                                <button
                                    onClick={() => {
                                        setShowTopUpPopup(false);
                                        setSelectedTopUp(null);
                                    }}
                                    className="flex-1 px-4 py-3 bg-gray-100 dark:bg-white/5 text-gray-900 dark:text-white font-bold text-sm uppercase rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
                                >
                                    CANCEL
                                </button>
                                <button
                                    disabled={!selectedTopUp || isTopUpLoading}
                                    onClick={handleTopUpSubmit}
                                    className={`flex-1 px-4 py-3 font-bold text-sm uppercase rounded-lg transition-colors flex items-center justify-center gap-2 ${selectedTopUp && !isTopUpLoading ? 'bg-gradient-to-r from-purple-500 to-pink-600 text-white hover:from-purple-600 hover:to-pink-700' : 'bg-gray-300 dark:bg-gray-700 text-gray-500 cursor-not-allowed opacity-50'}`}
                                >
                                    {isTopUpLoading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            PROCESSING...
                                        </>
                                    ) : "RECHARGE NOW"}
                                </button>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
            {/* ADD TEAMMATE POPUP */}
            {showAddTeammatePopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white dark:bg-[#1a1a24] p-[15px] rounded-xl border border-gray-200 dark:border-white/10 shadow-2xl max-w-sm w-full font-['Monda'] uppercase relative"
                    >
                        <button onClick={() => setShowAddTeammatePopup(false)} className="absolute top-[15px] right-[15px] text-gray-400 hover:text-pink-500 transition-colors z-10">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px] text-center">
                            <h3 className="font-['Monda'] text-xl font-black text-gray-900 dark:text-white uppercase tracking-wider">ADD TEAMMATE</h3>
                        </div>

                        {resolvedFriendsList.length > 0 && (
                            <div className="mb-[15px]">
                                <label className="text-[10px] text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">CHOOSE FROM FRIENDS</label>
                                <select
                                    className="w-full bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 font-black text-sm uppercase focus:outline-none focus:border-pink-500 transition-colors dark:text-white"
                                    onChange={(e) => {
                                        if (e.target.value === "") return;
                                        const selectedFriend = resolvedFriendsList[e.target.value];
                                        if (selectedFriend) {
                                            setAddTeammateForm({
                                                ...addTeammateForm,
                                                name: selectedFriend.resolvedName,
                                                uid: selectedFriend.resolvedUid,
                                                role: selectedFriend.resolvedRole,
                                                kd: selectedFriend.resolvedKd,
                                                avatar: selectedFriend.resolvedAvatar
                                            });
                                        }
                                    }}
                                    defaultValue=""
                                >
                                    <option value="" disabled>SELECT A FRIEND</option>
                                    {resolvedFriendsList.map((friend, idx) => (
                                        <option key={idx} value={idx}>
                                            {friend.resolvedName} - {friend.resolvedUid}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div className="mb-[20px] space-y-[15px]">
                            <div>
                                <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">IN-GAME NAME</label>
                                <input
                                    type="text"
                                    value={addTeammateForm.name}
                                    onChange={e => setAddTeammateForm({ ...addTeammateForm, name: e.target.value })}
                                    className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white text-center disabled:opacity-50 disabled:cursor-not-allowed"
                                    placeholder="PLAYER NAME"
                                    disabled
                                />
                            </div>
                            <div className="grid grid-cols-2 gap-[15px]">
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">GAME UID</label>
                                    <input
                                        type="text"
                                        value={addTeammateForm.uid}
                                        onChange={e => setAddTeammateForm({ ...addTeammateForm, uid: e.target.value })}
                                        className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white text-center disabled:opacity-50 disabled:cursor-not-allowed"
                                        placeholder="5123456789"
                                        disabled
                                    />
                                </div>
                                <div>
                                    <label className="text-xs text-gray-500 dark:text-gray-400 font-bold mb-2 block uppercase tracking-wider">ROLE</label>
                                    <select
                                        value={addTeammateForm.role}
                                        onChange={e => setAddTeammateForm({ ...addTeammateForm, role: e.target.value })}
                                        className="w-full font-black text-sm uppercase bg-gray-50 dark:bg-black/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 focus:outline-none focus:border-pink-500 transition-colors dark:text-white text-center appearance-none"
                                    >
                                        <option value="IGL">IGL</option>
                                        <option value="ASSAULTER">ASSAULTER</option>
                                        <option value="SUPPORT">SUPPORT</option>
                                        <option value="SNIPER">SNIPER</option>
                                        <option value="FRAGGER">FRAGGER</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-[15px]">
                            <button
                                onClick={() => setShowAddTeammatePopup(false)}
                                className="flex-1 py-3 rounded-lg bg-gray-200 dark:bg-white/5 text-gray-900 dark:text-white font-bold hover:bg-gray-300 dark:hover:bg-white/10 transition-colors"
                            >
                                CANCEL
                            </button>
                            <button
                                onClick={async () => {
                                    if (!addTeammateForm.name || !addTeammateForm.uid) return;

                                    const isSquadSlot = addTeammateForm.slotId.startsWith('squad');
                                    const isDuoSlot = addTeammateForm.slotId.startsWith('duo');

                                    const duplicateTeammate = myTeammates.find(t =>
                                        String(t.uid) === String(addTeammateForm.uid) &&
                                        (
                                            (isSquadSlot && t.slotId.startsWith('squad')) ||
                                            (isDuoSlot && t.slotId.startsWith('duo'))
                                        )
                                    );

                                    if (duplicateTeammate) {
                                        alert(`THIS GAME UID IS ALREADY ASSIGNED TO ANOTHER ${isSquadSlot ? "SQUAD" : "DUO"} SLOT!`);
                                        return;
                                    }

                                    setIsSavingTeammate(true);
                                    try {
                                        const docId = `TM_${Date.now()}`;
                                        await setDoc(doc(db, 'findTeammates', docId), {
                                            ...addTeammateForm,
                                            ownerId: gamerUser?.uid || gamerUser?.gamerCode,
                                            createdAt: Date.now()
                                        });
                                        setShowAddTeammatePopup(false);
                                    } catch (e) {
                                        console.error(e);
                                    }
                                    setIsSavingTeammate(false);
                                }}
                                disabled={isSavingTeammate || !addTeammateForm.name || !addTeammateForm.uid}
                                className="flex-1 py-3 rounded-lg bg-green-500 hover:bg-green-600 text-white font-black transition-colors disabled:opacity-50 flex justify-center items-center"
                            >
                                {isSavingTeammate ? (
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                ) : 'SAVE'}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
            {/* QR Code Modal */}
            {showQRModal && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowQRModal(false)}>
                    <div className="bg-white dark:bg-[#1a1a24] border border-pink-500/30 rounded-none w-full max-w-sm overflow-hidden flex flex-col relative font-['Monda'] shadow-[0_0_30px_rgba(219,39,119,0.2)]" onClick={e => e.stopPropagation()}>
                        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5">
                            <h3 className="text-lg font-black uppercase tracking-wider text-gray-900 dark:text-white">Share Referral</h3>
                            <button onClick={() => setShowQRModal(false)} className="text-gray-500 hover:text-pink-500 transition-colors">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                            </button>
                        </div>
                        <div className="p-6 flex flex-col items-center justify-center">
                            <div className="bg-white p-3 rounded-xl shadow-inner mb-4">
                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent((typeof window !== 'undefined' ? window.location.origin : '') + '?ref=' + (profile?.referralCode || profile?.playerId || 'GLPC-REF-001'))}`}
                                    alt="Referral QR Code"
                                    className="w-[200px] h-[200px]"
                                />
                            </div>
                            <p className="text-center text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-2">Scan to join via my link!</p>
                            <div className="text-xl font-black text-pink-600 dark:text-pink-400 tracking-widest bg-gray-100 dark:bg-white/5 px-4 py-2 rounded border border-gray-200 dark:border-white/10">
                                {profile?.referralCode || profile?.playerId || "GLPC-REF-001"}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
